var _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _g, _clipPath6, _clipPath7, _g2, _clipPath8, _clipPath9, _g3, _clipPath0, _clipPath1, _g4, _clipPath10, _g5, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15, _clipPath16, _g6, _clipPath17, _clipPath18, _g7, _clipPath19, _clipPath20, _g8, _clipPath21, _clipPath22, _g9, _clipPath23, _g0, _clipPath24, _defs9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTourIconStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 84 74",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M73.066,16.457c0,-0.85 0.689,-1.539 1.539,-1.539c0.85,0 1.539,0.689 1.539,1.539c0,0.85 -0.689,1.539 -1.539,1.539c-0.85,0 -1.539,-0.689 -1.539,-1.539Z",
    style: {
      fill: "#d0bedd",
      fillRule: "nonzero"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,-0,-0,1,0,0)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "_Image1",
    width: "84px",
    height: "74px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABKCAAAAAAA3Cz2AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAWElEQVRYhe3MoRVAAABF0X80guCIig1kwS5msIIJ7GIVa2jq11jgB8d5N730JAAAAAAAAAD4lbGJL7vD15KerrbPKrIqnuol1W1k+pps7+GnNGxzGZ/iy25AaA2CD1gdFgAAAABJRU5ErkJggg=="
  }))))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "Mask1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,-0,-0,1,0,0)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "_Image2",
    width: "84px",
    height: "74px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABKCAAAAAAA3Cz2AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAASklEQVRYhe3NoQ2AQBREwYVQASWhqBqDpJEz1PBxVHAkXDKjVr1NAAAAAACGN71rX5McrW/+qqrauqTmLpVho8u7zpbk/uKDv3oA7CwJrXF1pCsAAAAASUVORK5CYII="
  }))))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "Mask2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,-0,-0,1,0,0)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "_Image3",
    width: "84px",
    height: "74px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABKCAAAAAAA3Cz2AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAASUlEQVRYhe3NMQ2AQBREwYWATKwhBxFgAA8Un+4UHAmXzFRbvU0AAAAAAIY3tbXNSa6jb/6pqtq7pOYulWGjS1vnmuT+4oO/egEe4glogUKyHQAAAABJRU5ErkJggg=="
  }))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Mask2)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#Mask1)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#Mask)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.207,
    y: 63.65,
    width: 5.052,
    height: 5.05,
    style: {
      fill: "#d0bedd",
      fillRule: "nonzero"
    }
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "Mask3"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,-0,-0,1,0,0)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "_Image4",
    width: "84px",
    height: "74px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABKCAAAAAAA3Cz2AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAP0lEQVRYhe3MMQ2AMBAAwE+adK4OVCCxGxOOKgEh3WD9hPXHOwEXAQAAAAAAP62mOe6xaqbkencvT89nlp9kHy1LBef4ALLFAAAAAElFTkSuQmCC"
  }))))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "Mask4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,-0,-0,1,0,0)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "_Image5",
    width: "84px",
    height: "74px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABKCAAAAAAA3Cz2AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAOElEQVRYhe3MoRUAEBRAUcEMugnsajILcUSK9rV72ysvJQAAAAAA+KWPUU7lmGlt9yloumbMh5cNHD4EoBDLdIwAAAAASUVORK5CYII="
  }))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Mask4)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#Mask3)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.303,
    y: 67.187,
    width: 2.799,
    height: 2.798,
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "Mask5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,-0,-0,1,0,0)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "_Image6",
    width: "84px",
    height: "74px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABKCAAAAAAA3Cz2AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAARUlEQVRYhe3MsRFAABQFsIdK7VhCawB7WcN+zhJKDOFXLhkgCQAAAMAfTWtTfo7Xsxd2bZJk7rMUpl2S5Bzu7ShcAeC7F3ijBq/xdmLTAAAAAElFTkSuQmCC"
  }))))), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "Mask6"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,-0,-0,1,0,0)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "_Image7",
    width: "84px",
    height: "74px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABKCAAAAAAA3Cz2AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAARUlEQVRYhe3MwQ2AIBAAwcVYimVQjOXR2iX84Yc/CzDHx+wUMCBJkiRJkvQrBYCrMlt2fa8Vid2ReL1OAEbQd+ySJH33ANXFCBt78aJZAAAAAElFTkSuQmCC"
  }))))), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "Mask7"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,-0,-0,1,0,0)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "_Image8",
    width: "84px",
    height: "74px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABKCAAAAAAA3Cz2AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAANklEQVRYhe3MQREAIQwEsOUcMQjEyHktJsqHSQQkAQAAAHjKSJLMlfzd9a6qxu5rvO6mANDgADChBII8JEtBAAAAAElFTkSuQmCC"
  }))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Mask7)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#Mask6)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#Mask5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.625,
    y: 51.624,
    width: 3.284,
    height: 3.283,
    style: {
      fill: "#d0bedd",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M78.948,64.52c0,-1.395 1.131,-2.525 2.526,-2.525c1.395,0 2.526,1.131 2.526,2.525c0,1.395 -1.131,2.525 -2.526,2.525c-1.395,0 -2.526,-1.131 -2.526,-2.525Z",
    style: {
      fill: "#d0bedd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37,22.856c0,-1.395 1.131,-2.525 2.526,-2.525c1.395,0 2.526,1.131 2.526,2.525c0,1.395 -1.131,2.525 -2.526,2.525c-1.395,0 -2.526,-1.131 -2.526,-2.525Z",
    style: {
      fill: "#d0bedd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.826,22.513c0,-1.395 1.131,-2.525 2.526,-2.525c1.395,0 2.526,1.131 2.526,2.525c0,1.395 -1.131,2.525 -2.526,2.525c-1.395,0 -2.526,-1.13 -2.526,-2.525Z",
    style: {
      fill: "#d0bedd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.836,19.214l-7.964,-8.749c-0.709,-0.782 -1.793,-1.15 -2.847,-0.964l-38.741,6.853c-1.053,0.186 -1.945,0.904 -2.343,1.882l-4.49,10.952c-2.315,5.651 1.781,12.217 7.929,11.97c0.444,-0.023 0.895,-0.069 1.329,-0.145c2.834,-0.501 5.134,-2.185 6.522,-4.402c2.064,1.606 4.803,2.398 7.636,1.897c2.834,-0.501 5.134,-2.185 6.522,-4.402c2.065,1.606 4.803,2.398 7.636,1.897c2.845,-0.503 5.134,-2.185 6.522,-4.402c2.075,1.604 4.803,2.398 7.636,1.897c0.445,-0.079 0.874,-0.188 1.298,-0.319c5.884,-1.87 7.489,-9.444 3.363,-13.967l-0.011,0.002Zm-2.298,17.329l-0.011,0.002c-0.562,0.178 -1.141,0.325 -1.738,0.431c-1.346,0.238 -2.675,0.26 -3.945,0.104l2.561,14.476l-34.745,6.147l-2.563,-14.487c-1.149,0.595 -2.415,1.032 -3.762,1.27c-0.597,0.106 -1.202,0.168 -1.791,0.194l-0.011,0.002c-0.457,0.014 -0.904,0.014 -1.347,-0.019l2.524,14.27l1.23,6.95c0.678,3.834 4.346,6.399 8.178,5.721l34.745,-6.147c3.833,-0.678 6.398,-4.346 5.719,-8.179l-1.23,-6.95l-2.524,-14.27c-0.415,0.185 -0.834,0.349 -1.291,0.486Z",
    style: {
      fill: "#662d91",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M67.584,25.047l6.05,-1.152l-0.637,6.162l-10.727,9.868l-3.44,-3.095l8.754,-11.782Z",
    style: {
      fill: "#f1c41f"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M68.11,32.642l3.641,0.305l-1.356,3.544l-7.717,4.091l-1.466,-2.394l6.898,-5.547Z",
    style: {
      fill: "#f7d55a"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.182,28.382l2.735,-2.653l1.789,3.135l-2.159,8.404l-2.844,-0.265l0.48,-8.622Z",
    style: {
      fill: "#f7d55a"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.314,32.655l5.536,2.871l-4.818,4.548l-5.536,-2.871l4.818,-4.548Z",
    style: {
      fill: "#ffe37d"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.436,47.502l-0.832,-6.102l6.12,0.96l9.289,11.232l-3.272,3.272l-11.305,-9.362Z",
    style: {
      fill: "#f1c41f"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.048,47.376l0.497,-3.62l3.468,1.541l3.679,7.921l-2.468,1.338l-5.176,-7.18Z",
    style: {
      fill: "#f7d55a"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.324,56.068l-2.506,-2.87l3.225,-1.621l8.279,2.598l-0.414,2.826l-8.584,-0.933Z",
    style: {
      fill: "#f7d55a"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M62.809,52.166l3.159,-5.377l4.288,5.051l-3.159,5.377l-4.288,-5.051Z",
    style: {
      fill: "#ffe37d"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M66.717,24.896l5.387,-1.883l0.558,5.706l-8.095,10.473l-3.761,-2.35l5.912,-11.947Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.96
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.717,24.896l5.387,-1.883l0.558,5.706l-8.095,10.473l-3.761,-2.35l5.912,-11.947Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.192,27.668c-1.94,4.369 4.145,8.534 4.817,8.993c-1.353,1.537 -4.433,7.479 -9.984,2.953c-2.826,-2.304 0.053,-5.234 3.158,-9.72c0.353,-0.51 2.045,-1.906 2.183,-1.939",
    style: {
      fill: "#0074ae",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.112,38.586c3.227,-2.209 6.252,-6.861 10.922,-12.064c1.612,-1.795 1.477,-0.785 0.561,1.777c-4.883,13.664 -8.975,12.077 -9.985,11.685c-1.91,-0.741 -2.259,-0.181 -2.156,-0.347",
    style: {
      fill: "#004a6f",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.727,25.07c0.39,-0.092 1.07,0.299 1.203,0.316c-0.148,0.333 -0.349,0.368 -1.987,4.223c-1.195,2.812 0.307,0.198 0.681,-0.475c0.844,-1.52 1.867,-3.494 1.945,-3.53c0.091,-0.042 1.616,0.713 0.992,-0.021c-0.059,-0.069 -0.637,-0.467 -0.637,-0.467l-0.501,-0.241c0,0 -0.947,-0.074 -1.612,0.07",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.468,25.08c0.275,0.218 1.227,0.967 1.532,1.108c0.979,0.455 -0.681,-0.065 -1.694,-0.98c-0.042,-0.038 -0.106,-0.097 -0.08,-0.163c0.081,-0.213 1.286,-0.707 1.324,-0.719c0.538,-0.172 -0.34,0.17 -1.082,0.753Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.852,23.415c-2.989,1.584 -3.036,1.523 -3.262,1.734c-0.005,0.004 -1.636,3.172 -6.477,12.414c-0.011,0.021 -0.043,0.122 -0.102,0.092c-0.108,-0.055 -0.006,-0.096 0.881,-1.859c4.537,-9.013 5.469,-10.85 5.523,-10.878c3.499,-1.895 3.714,-2.113 3.755,-1.783c0.003,0.02 -0.15,4.024 -0.167,4.071c-0.03,0.085 -8.438,11.356 -8.447,11.362c-0.006,0.004 -0.148,0.043 -0.078,-0.057c1.124,-1.605 7.089,-9.817 7.708,-10.669c0.178,-0.245 0.461,-0.441 0.535,-0.734c0.076,-0.3 0.014,-0.312 0.131,-3.691Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.079,31.457c-0.16,-0.289 -1.073,-1.916 -2.312,-4.189c-0.072,-0.132 -0.139,-0.053 -3.199,-2.021c-0.322,-0.207 -0.355,-0.102 -1.845,-0.177c-1.296,-0.066 -2.599,-0.139 -3.132,-0.168c4.829,-0.007 4.839,-0.034 4.925,0.017c1.286,0.761 3.114,1.943 3.382,2.116c0.103,0.067 0.072,0.092 2.18,4.423Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.222,23.48l5.387,-1.883c0.435,-0.152 0.915,-0.096 1.303,0.152c0.388,0.248 0.64,0.66 0.685,1.118l0.558,5.706c0.037,0.38 -0.072,0.761 -0.306,1.063l-8.095,10.473c-0.471,0.61 -1.328,0.763 -1.982,0.355l-3.761,-2.35c-0.654,-0.409 -0.892,-1.246 -0.55,-1.937l5.912,-11.947c0.174,-0.352 0.479,-0.621 0.85,-0.751Zm0.495,1.416l-5.912,11.947l3.761,2.35l8.095,-10.473l-0.558,-5.706l-5.387,1.883Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.182,29.557l2.038,-2.795l2.24,2.613l-0.434,7.961l-2.683,0.149l-1.161,-7.928Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.96
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.182,29.557l2.038,-2.795l2.24,2.613l-0.434,7.961l-2.683,0.149l-1.161,-7.928Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.375,31.449c0.535,2.822 5,2.759 5.493,2.752c-0.146,1.226 0.362,5.217 -3.961,4.917c-2.201,-0.153 -1.773,-2.593 -1.768,-5.877c0.001,-0.374 0.364,-1.647 0.421,-1.711",
    style: {
      fill: "#0074ae",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.092,37.541c0.849,-2.206 0.757,-5.544 1.297,-9.724c0.186,-1.442 0.466,-0.899 0.891,0.679c2.264,8.416 -0.321,9.055 -0.959,9.213c-1.206,0.298 -1.188,0.695 -1.194,0.577",
    style: {
      fill: "#fff",
      fillOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.246,29.639c0.163,-0.181 0.636,-0.224 0.708,-0.262c0.041,0.215 -0.047,0.302 0.462,2.767c0.371,1.798 0.221,-0.009 0.176,-0.47c-0.102,-1.041 -0.271,-2.366 -0.244,-2.411c0.031,-0.052 1.05,-0.21 0.487,-0.354c-0.053,-0.014 -0.478,-0.009 -0.478,-0.009l-0.332,0.055c0,0 -0.498,0.292 -0.78,0.594",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.625,28.703c0.218,-0.011 0.831,0.044 1.105,0.007c0.008,-0.001 0.197,-0.023 0.094,0.02c-0.22,0.094 -1.324,0.154 -1.34,0.023c-0.022,-0.179 0.677,-1.258 0.385,-0.657c-0.146,0.301 -0.159,0.291 -0.225,0.493c-0.011,0.033 -0.014,0.078 -0.019,0.113Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.233,27.045c-0.946,1.819 -0.99,1.804 -1.031,1.987c-0.004,0.016 2.119,16.577 0.417,4.307c-0.59,-4.257 -0.595,-4.338 -0.583,-4.362c1.086,-2.149 1.095,-2.326 1.244,-2.191c0.032,0.029 1.323,2.05 1.33,2.072c0.013,0.046 -0.491,14.583 -0.317,6.337c0.108,-5.126 0.146,-6.283 0.144,-6.289c-0.065,-0.174 -0.1,-0.159 -1.204,-1.862Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.108,30.229c-0.226,-0.109 -1.167,-0.558 -2.605,-1.265c-0.052,-0.026 -0.162,0.033 -2.288,0.123c-0.145,0.006 -0.137,0.043 -2.591,1.558c2.405,-1.68 2.397,-1.694 2.462,-1.703c0.077,-0.01 1.544,-0.104 2.413,-0.132c0.072,-0.002 0.066,0.02 2.608,1.419Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.97,28.673l2.038,-2.795c0.27,-0.371 0.695,-0.597 1.153,-0.615c0.458,-0.018 0.899,0.175 1.198,0.523l2.24,2.613c0.251,0.293 0.38,0.672 0.359,1.058l-0.434,7.961c-0.042,0.763 -0.651,1.373 -1.414,1.416l-2.683,0.149c-0.775,0.043 -1.455,-0.512 -1.568,-1.28l-1.161,-7.928c-0.057,-0.388 0.041,-0.784 0.272,-1.101Zm1.212,0.884l1.161,7.928l2.683,-0.149l0.434,-7.961l-2.24,-2.613l-2.038,2.795Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M68.618,31.75l3.428,-0.222l-0.596,3.418l-6.383,4.792l-1.803,-1.982l5.354,-6.006Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.96
    }
  }), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.618,31.75l3.428,-0.222l-0.596,3.418l-6.383,4.792l-1.803,-1.982l5.354,-6.006Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.287,33.118c-1.829,2.232 1.03,5.651 1.346,6.028c-1.033,0.676 -3.776,3.641 -6.267,0.099c-1.268,-1.803 0.874,-3.044 3.398,-5.155c0.287,-0.24 1.493,-0.779 1.579,-0.776",
    style: {
      fill: "#0074ae",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.322,39.147c2.228,-0.764 4.732,-2.985 8.279,-5.26c1.224,-0.785 0.983,-0.218 0.039,1.127c-5.034,7.175 -7.152,5.584 -7.674,5.191c-0.988,-0.742 -1.282,-0.473 -1.195,-0.553",
    style: {
      fill: "#004a6f",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.596,31.852c0.241,0.01 0.572,0.349 0.647,0.38c-0.139,0.17 -0.262,0.158 -1.833,2.14c-1.146,1.445 0.146,0.165 0.472,-0.167c0.735,-0.749 1.646,-1.734 1.697,-1.742c0.059,-0.01 0.822,0.678 0.579,0.149c-0.023,-0.05 -0.294,-0.376 -0.294,-0.376l-0.252,-0.222c0,0 -0.537,-0.197 -0.947,-0.221",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.182,32.318c0.146,0.162 0.49,0.673 0.69,0.861c0.006,0.006 0.142,0.137 0.043,0.086c-0.212,-0.111 -0.952,-0.927 -0.862,-1.023c0.124,-0.133 1.393,-0.285 0.748,-0.125c-0.323,0.08 -0.323,0.064 -0.52,0.144c-0.033,0.013 -0.069,0.04 -0.099,0.058Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.835,31.721l-2.171,0.481c-0.015,0.008 -11.384,12.314 -3.049,3.102c2.912,-3.219 2.959,-3.26 2.985,-3.266c2.335,-0.543 2.48,-0.645 2.467,-0.445c-0.003,0.04 -0.739,2.342 -0.753,2.362c-0.027,0.039 -11.506,9.017 -5.064,3.835c3.996,-3.214 4.911,-3.933 4.914,-3.938c0.092,-0.163 0.059,-0.18 0.671,-2.131Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.832,36.773c-0.041,-0.172 -0.317,-1.305 -0.666,-2.813c-0.02,-0.088 -0.099,-0.088 -1.527,-1.7c-0.125,-0.142 -0.155,-0.1 -2.838,-1.016c2.805,0.782 2.811,0.767 2.857,0.812c0.066,0.063 1.07,1.148 1.621,1.784c0.05,0.058 0.028,0.068 0.552,2.934Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.521,30.253l3.428,-0.222c0.459,-0.03 0.906,0.153 1.213,0.495c0.307,0.342 0.44,0.806 0.361,1.259l-0.596,3.418c-0.066,0.376 -0.272,0.713 -0.577,0.942l-6.383,4.792c-0.619,0.464 -1.489,0.382 -2.01,-0.19l-1.803,-1.982c-0.517,-0.568 -0.521,-1.434 -0.01,-2.008l5.354,-6.006c0.262,-0.294 0.63,-0.473 1.023,-0.499Zm0.097,1.497l-5.354,6.006l1.803,1.982l6.383,-4.792l0.596,-3.418l-3.428,0.222Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.318,34.466l5.497,1.328l-3.776,4.281l-4.268,-0.451l-1.229,-0.877l3.776,-4.281Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.96,
      stroke: "#fff",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.815,35.794l-9.274,2.952l0.311,-1.221l3.465,-3.06l1.721,5.609",
    style: {
      fill: "#fff",
      fillOpacity: 0.96,
      stroke: "#fff",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.731,35.815l2.851,0.679l-1.964,2.212l-4.193,-0.229l3.306,-2.661Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.96
    }
  }), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.731,35.815l2.851,0.679l-1.964,2.212l-4.193,-0.229l3.306,-2.661Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.061,35.215l-1.536,3.737l-0.267,-0.164l1.326,-3.673l0.477,0.1Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.289,35.282l-1.296,3.692l-0.109,-0.021l1.343,-3.662l0.062,-0.009Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.731,35.815l2.851,0.679l-1.964,2.212l-4.193,-0.229l3.306,-2.661Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "1.5px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.717,24.896l5.387,-1.883l0.558,5.706l-8.095,10.473l-3.761,-2.35l5.912,-11.947Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip13)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image14",
    x: 60.805,
    y: 23.014,
    width: "12px",
    height: "17px"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.717,24.896l5.387,-1.883l0.558,5.706l-8.095,10.473l-3.761,-2.35l5.912,-11.947Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.192,27.668c-1.94,4.369 4.145,8.534 4.817,8.993c-1.353,1.537 -4.433,7.479 -9.984,2.953c-2.826,-2.304 0.053,-5.234 3.158,-9.72c0.353,-0.51 2.045,-1.906 2.183,-1.939",
    style: {
      fill: "#0074ae",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.112,38.586c3.227,-2.209 6.252,-6.861 10.922,-12.064c1.612,-1.795 1.477,-0.785 0.561,1.777c-4.883,13.664 -8.975,12.077 -9.985,11.685c-1.91,-0.741 -2.259,-0.181 -2.156,-0.347",
    style: {
      fill: "#004a6f",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.727,25.07c0.39,-0.092 1.07,0.299 1.203,0.316c-0.148,0.333 -0.349,0.368 -1.987,4.223c-1.195,2.812 0.307,0.198 0.681,-0.475c0.844,-1.52 1.867,-3.494 1.945,-3.53c0.091,-0.042 1.616,0.713 0.992,-0.021c-0.059,-0.069 -0.637,-0.467 -0.637,-0.467l-0.501,-0.241c0,0 -0.947,-0.074 -1.612,0.07",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.468,25.08c0.275,0.218 1.227,0.967 1.532,1.108c0.979,0.455 -0.681,-0.065 -1.694,-0.98c-0.042,-0.038 -0.106,-0.097 -0.08,-0.163c0.081,-0.213 1.286,-0.707 1.324,-0.719c0.538,-0.172 -0.34,0.17 -1.082,0.753Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.852,23.415c-2.989,1.584 -3.036,1.523 -3.262,1.734c-0.005,0.004 -1.636,3.172 -6.477,12.414c-0.011,0.021 -0.043,0.122 -0.102,0.092c-0.108,-0.055 -0.006,-0.096 0.881,-1.859c4.537,-9.013 5.469,-10.85 5.523,-10.878c3.499,-1.895 3.714,-2.113 3.755,-1.783c0.003,0.02 -0.15,4.024 -0.167,4.071c-0.03,0.085 -8.438,11.356 -8.447,11.362c-0.006,0.004 -0.148,0.043 -0.078,-0.057c1.124,-1.605 7.089,-9.817 7.708,-10.669c0.178,-0.245 0.461,-0.441 0.535,-0.734c0.076,-0.3 0.014,-0.312 0.131,-3.691Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.079,31.457c-0.16,-0.289 -1.073,-1.916 -2.312,-4.189c-0.072,-0.132 -0.139,-0.053 -3.199,-2.021c-0.322,-0.207 -0.355,-0.102 -1.845,-0.177c-1.296,-0.066 -2.599,-0.139 -3.132,-0.168c4.829,-0.007 4.839,-0.034 4.925,0.017c1.286,0.761 3.114,1.943 3.382,2.116c0.103,0.067 0.072,0.092 2.18,4.423Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.613,24.6l5.387,-1.883c0.091,-0.032 0.191,-0.02 0.272,0.032c0.081,0.052 0.134,0.138 0.143,0.234l0.558,5.706c0.008,0.08 -0.015,0.159 -0.064,0.222l-8.095,10.473c-0.099,0.127 -0.278,0.16 -0.414,0.074l-3.761,-2.35c-0.137,-0.085 -0.186,-0.261 -0.115,-0.405l5.912,-11.947c0.036,-0.074 0.1,-0.13 0.178,-0.157Zm0.103,0.296l-5.912,11.947l3.761,2.35l8.095,-10.473l-0.558,-5.706l-5.387,1.883Z",
    style: {
      fill: "#00ceff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.098,25.925c0.027,-0.125 -0.002,-0.256 -0.079,-0.358l-0.937,-1.22l1.031,1.14c0.068,0.075 0.16,0.123 0.259,0.137c-0,-0.004 -0,-0.008 -0.001,-0.011l-0.072,-1.022l0.153,1.012c0.001,0.008 0.003,0.017 0.005,0.025c0.003,-0 0.005,-0 0.008,-0.001c0.133,-0.01 0.254,-0.08 0.329,-0.191l0.874,-1.283l-0.77,1.348c-0.056,0.098 -0.072,0.213 -0.046,0.32l0.939,-0.391l-0.912,0.468c-0,0 -0,0 -0,0c0.052,0.115 0.151,0.202 0.272,0.237l1.477,0.426l-1.507,-0.307c-0.12,-0.024 -0.245,0.003 -0.344,0.076c0.003,0.005 0.007,0.009 0.011,0.013l0.657,0.778l-0.716,-0.723c-0.004,-0.004 -0.009,-0.009 -0.013,-0.013c-0.078,0.084 -0.121,0.196 -0.118,0.311l0.039,1.547l-0.161,-1.538c-0.012,-0.118 -0.072,-0.224 -0.164,-0.296c-0.012,0.013 -0.022,0.027 -0.032,0.043l-0.54,0.875l0.47,-0.914c0.009,-0.017 0.016,-0.035 0.021,-0.053c-0.103,-0.048 -0.222,-0.054 -0.331,-0.014l-1.453,0.53l1.408,-0.643c0.096,-0.044 0.172,-0.121 0.216,-0.215c-0.015,-0.006 -0.03,-0.012 -0.047,-0.016l-0.99,-0.237l1.007,0.158c0.02,0.003 0.041,0.004 0.061,0.003Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.693,32.254c0.015,-0.071 -0.001,-0.145 -0.045,-0.202l-0.529,-0.688l0.582,0.643c0.038,0.042 0.09,0.069 0.146,0.077c-0,-0.002 -0,-0.004 -0,-0.006l-0.041,-0.576l0.086,0.571c0.001,0.005 0.002,0.009 0.003,0.014c0.001,-0 0.003,-0 0.004,-0c0.075,-0.006 0.143,-0.045 0.186,-0.108l0.493,-0.724l-0.435,0.76c-0.032,0.055 -0.041,0.12 -0.026,0.181l0.53,-0.221l-0.515,0.264c-0,0 -0,0 -0,0c0.029,0.065 0.085,0.114 0.154,0.133l0.833,0.241l-0.85,-0.173c-0.068,-0.014 -0.138,0.002 -0.194,0.043c0.002,0.003 0.004,0.005 0.006,0.007l0.37,0.439l-0.404,-0.408c-0.002,-0.002 -0.005,-0.005 -0.008,-0.007c-0.044,0.047 -0.068,0.11 -0.066,0.175l0.022,0.873l-0.091,-0.867c-0.007,-0.066 -0.04,-0.126 -0.092,-0.167c-0.007,0.007 -0.013,0.015 -0.018,0.024l-0.304,0.494l0.265,-0.516c0.005,-0.01 0.009,-0.02 0.012,-0.03c-0.058,-0.027 -0.125,-0.031 -0.187,-0.008l-0.819,0.299l0.794,-0.363c0.054,-0.025 0.097,-0.068 0.122,-0.121c-0.008,-0.004 -0.017,-0.007 -0.026,-0.009l-0.559,-0.134l0.568,0.089c0.012,0.002 0.023,0.002 0.035,0.002Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.089,23.788c0.015,-0.071 -0.001,-0.145 -0.045,-0.202l-0.529,-0.688l0.582,0.643c0.038,0.042 0.09,0.069 0.146,0.077c-0,-0.002 -0,-0.004 -0,-0.006l-0.041,-0.576l0.086,0.571c0.001,0.005 0.002,0.009 0.003,0.014c0.001,-0 0.003,-0 0.004,-0c0.075,-0.006 0.143,-0.045 0.186,-0.108l0.493,-0.724l-0.435,0.76c-0.032,0.055 -0.041,0.12 -0.026,0.181l0.53,-0.221l-0.515,0.264c-0,0 -0,0 -0,0c0.029,0.065 0.085,0.114 0.154,0.133l0.833,0.241l-0.85,-0.173c-0.068,-0.014 -0.138,0.002 -0.194,0.043c0.002,0.003 0.004,0.005 0.006,0.007l0.37,0.439l-0.404,-0.408c-0.002,-0.002 -0.005,-0.005 -0.008,-0.007c-0.044,0.047 -0.068,0.11 -0.066,0.175l0.022,0.873l-0.091,-0.867c-0.007,-0.066 -0.04,-0.126 -0.092,-0.167c-0.007,0.007 -0.013,0.015 -0.018,0.024l-0.304,0.494l0.265,-0.516c0.005,-0.01 0.009,-0.02 0.012,-0.03c-0.058,-0.027 -0.125,-0.031 -0.187,-0.008l-0.819,0.299l0.794,-0.363c0.054,-0.025 0.097,-0.068 0.122,-0.121c-0.008,-0.004 -0.017,-0.007 -0.026,-0.009l-0.559,-0.134l0.568,0.089c0.012,0.002 0.023,0.002 0.035,0.002Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.311,26.986c0.06,-0.04 0.101,-0.104 0.11,-0.177l0.109,-0.867l-0.04,0.873c-0.003,0.058 0.015,0.114 0.049,0.158c0.001,-0.002 0.003,-0.003 0.004,-0.005l0.374,-0.443l-0.339,0.471c-0.003,0.004 -0.005,0.008 -0.008,0.012c0.001,0.001 0.002,0.002 0.003,0.003c0.057,0.049 0.133,0.069 0.206,0.054l0.854,-0.172l-0.838,0.239c-0.061,0.017 -0.113,0.058 -0.145,0.111l0.528,0.215l-0.547,-0.174c-0,-0 -0,-0 -0,-0c-0.025,0.067 -0.02,0.142 0.015,0.204l0.419,0.761l-0.478,-0.725c-0.038,-0.058 -0.099,-0.096 -0.166,-0.106c-0,0.003 -0.001,0.006 -0.001,0.01l-0.046,0.577l0,-0.578c0,-0.004 -0,-0.007 -0,-0.011c-0.064,0.003 -0.125,0.031 -0.17,0.079l-0.595,0.642l0.543,-0.687c0.042,-0.053 0.06,-0.119 0.052,-0.185c-0.01,0.001 -0.02,0.002 -0.029,0.005l-0.56,0.139l0.547,-0.183c0.01,-0.003 0.02,-0.008 0.029,-0.013c-0.022,-0.061 -0.067,-0.11 -0.126,-0.138l-0.786,-0.364l0.813,0.3c0.056,0.02 0.116,0.02 0.171,-0.001c-0.003,-0.009 -0.008,-0.017 -0.012,-0.025l-0.3,-0.491l0.338,0.465c0.007,0.009 0.015,0.018 0.023,0.026Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.021,29.663c-0.044,-0.047 -0.107,-0.072 -0.172,-0.068l-0.779,0.048l0.773,-0.11c0.051,-0.007 0.098,-0.032 0.132,-0.07c-0.002,-0.001 -0.003,-0.002 -0.005,-0.003l-0.446,-0.259l0.465,0.222c0.004,0.002 0.008,0.003 0.012,0.005c0.001,-0.001 0.001,-0.002 0.002,-0.003c0.034,-0.058 0.04,-0.129 0.016,-0.192l-0.279,-0.729l0.336,0.704c0.024,0.051 0.067,0.09 0.12,0.11l0.11,-0.504l-0.071,0.515c-0,0 -0,0 -0,0c0.063,0.011 0.128,-0.006 0.177,-0.047l0.606,-0.499l-0.566,0.545c-0.045,0.043 -0.07,0.104 -0.068,0.166c0.003,-0 0.006,-0 0.009,-0.001l0.514,-0.055l-0.509,0.096c-0.003,0.001 -0.006,0.001 -0.009,0.002c0.012,0.056 0.046,0.106 0.095,0.137l0.654,0.421l-0.686,-0.367c-0.053,-0.028 -0.114,-0.033 -0.17,-0.015c0.002,0.009 0.005,0.017 0.008,0.025l0.207,0.474l-0.243,-0.455c-0.005,-0.008 -0.01,-0.016 -0.016,-0.024c-0.05,0.03 -0.087,0.078 -0.102,0.135l-0.202,0.759l0.142,-0.772c0.01,-0.053 -0,-0.106 -0.027,-0.152c-0.007,0.004 -0.014,0.009 -0.02,0.015l-0.386,0.348l0.358,-0.378c0.007,-0.008 0.014,-0.016 0.019,-0.025Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", null, _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.182,29.557l2.038,-2.795l2.24,2.613l-0.434,7.961l-2.683,0.149l-1.161,-7.928Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip16)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image17",
    x: 59.182,
    y: 26.761,
    width: "5px",
    height: "11px"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.182,29.557l2.038,-2.795l2.24,2.613l-0.434,7.961l-2.683,0.149l-1.161,-7.928Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.375,31.449c0.535,2.822 5,2.759 5.493,2.752c-0.146,1.226 0.362,5.217 -3.961,4.917c-2.201,-0.153 -1.773,-2.593 -1.768,-5.877c0.001,-0.374 0.364,-1.647 0.421,-1.711",
    style: {
      fill: "#0074ae",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.092,37.541c0.849,-2.206 0.757,-5.544 1.297,-9.724c0.186,-1.442 0.466,-0.899 0.891,0.679c2.264,8.416 -0.321,9.055 -0.959,9.213c-1.206,0.298 -1.188,0.695 -1.194,0.577",
    style: {
      fill: "#fff",
      fillOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.246,29.639c0.163,-0.181 0.636,-0.224 0.708,-0.262c0.041,0.215 -0.047,0.302 0.462,2.767c0.371,1.798 0.221,-0.009 0.176,-0.47c-0.102,-1.041 -0.271,-2.366 -0.244,-2.411c0.031,-0.052 1.05,-0.21 0.487,-0.354c-0.053,-0.014 -0.478,-0.009 -0.478,-0.009l-0.332,0.055c0,0 -0.498,0.292 -0.78,0.594",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.625,28.703c0.218,-0.011 0.831,0.044 1.105,0.007c0.008,-0.001 0.197,-0.023 0.094,0.02c-0.22,0.094 -1.324,0.154 -1.34,0.023c-0.022,-0.179 0.677,-1.258 0.385,-0.657c-0.146,0.301 -0.159,0.291 -0.225,0.493c-0.011,0.033 -0.014,0.078 -0.019,0.113Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.233,27.045c-0.946,1.819 -0.99,1.804 -1.031,1.987c-0.004,0.016 2.119,16.577 0.417,4.307c-0.59,-4.257 -0.595,-4.338 -0.583,-4.362c1.086,-2.149 1.095,-2.326 1.244,-2.191c0.032,0.029 1.323,2.05 1.33,2.072c0.013,0.046 -0.491,14.583 -0.317,6.337c0.108,-5.126 0.146,-6.283 0.144,-6.289c-0.065,-0.174 -0.1,-0.159 -1.204,-1.862Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.108,30.229c-0.226,-0.109 -1.167,-0.558 -2.605,-1.265c-0.052,-0.026 -0.162,0.033 -2.288,0.123c-0.145,0.006 -0.137,0.043 -2.591,1.558c2.405,-1.68 2.397,-1.694 2.462,-1.703c0.077,-0.01 1.544,-0.104 2.413,-0.132c0.072,-0.002 0.066,0.02 2.608,1.419Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.03,29.446l2.038,-2.795c0.034,-0.047 0.087,-0.075 0.145,-0.077c0.058,-0.002 0.113,0.022 0.15,0.066l2.24,2.613c0.032,0.037 0.048,0.084 0.045,0.133l-0.434,7.961c-0.005,0.096 -0.082,0.172 -0.177,0.178l-2.683,0.149c-0.097,0.005 -0.183,-0.064 -0.197,-0.161l-1.161,-7.928c-0.007,-0.049 0.005,-0.098 0.034,-0.138Zm0.152,0.111l1.161,7.928l2.683,-0.149l0.434,-7.961l-2.24,-2.613l-2.038,2.795Z",
    style: {
      fill: "#00ceff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.224,29.583c-0.03,-0.071 -0.089,-0.126 -0.163,-0.148l-0.886,-0.275l0.906,0.203c0.06,0.013 0.122,0.005 0.176,-0.022c-0.001,-0.002 -0.003,-0.004 -0.004,-0.005l-0.387,-0.477l0.424,0.445c0.003,0.004 0.007,0.007 0.011,0.01c0.001,-0.001 0.002,-0.002 0.004,-0.003c0.063,-0.051 0.099,-0.128 0.098,-0.208l-0.006,-0.934l0.079,0.93c0.006,0.068 0.037,0.13 0.087,0.174l0.333,-0.518l-0.294,0.547c-0,0 -0,0 -0,0c0.065,0.039 0.145,0.047 0.217,0.022l0.883,-0.303l-0.857,0.372c-0.068,0.03 -0.121,0.087 -0.145,0.157c0.003,0.001 0.006,0.002 0.01,0.003l0.595,0.155l-0.606,-0.107c-0.004,-0.001 -0.007,-0.001 -0.011,-0.002c-0.01,0.068 0.007,0.138 0.048,0.194l0.551,0.747l-0.609,-0.701c-0.047,-0.054 -0.113,-0.085 -0.183,-0.089c-0.001,0.011 -0.002,0.021 -0.001,0.032l0.032,0.618l-0.08,-0.613c-0.001,-0.011 -0.004,-0.023 -0.008,-0.033c-0.068,0.012 -0.129,0.051 -0.17,0.108l-0.542,0.765l0.481,-0.805c0.033,-0.055 0.044,-0.119 0.034,-0.181c-0.01,0.002 -0.019,0.005 -0.029,0.009l-0.575,0.227l0.556,-0.272c0.011,-0.006 0.022,-0.012 0.032,-0.02Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.198,32.837c-0.017,-0.04 -0.05,-0.071 -0.092,-0.084l-0.5,-0.155l0.511,0.115c0.034,0.008 0.069,0.003 0.099,-0.013c-0.001,-0.001 -0.002,-0.002 -0.002,-0.003l-0.218,-0.269l0.239,0.251c0.002,0.002 0.004,0.004 0.006,0.006c0.001,-0.001 0.001,-0.001 0.002,-0.002c0.035,-0.029 0.056,-0.072 0.056,-0.117l-0.003,-0.527l0.045,0.525c0.003,0.038 0.021,0.073 0.049,0.098l0.188,-0.292l-0.166,0.308c-0,0 -0,0 -0,0c0.037,0.022 0.082,0.026 0.122,0.012l0.498,-0.171l-0.483,0.21c-0.038,0.017 -0.068,0.049 -0.082,0.088c0.002,0.001 0.004,0.001 0.006,0.002l0.336,0.087l-0.342,-0.06c-0.002,-0 -0.004,-0.001 -0.006,-0.001c-0.006,0.039 0.004,0.078 0.027,0.109l0.311,0.421l-0.344,-0.395c-0.026,-0.03 -0.064,-0.048 -0.103,-0.05c-0.001,0.006 -0.001,0.012 -0.001,0.018l0.018,0.348l-0.045,-0.346c-0.001,-0.006 -0.002,-0.013 -0.004,-0.019c-0.038,0.007 -0.073,0.029 -0.096,0.061l-0.306,0.431l0.271,-0.454c0.019,-0.031 0.025,-0.067 0.019,-0.102c-0.005,0.001 -0.011,0.003 -0.016,0.005l-0.324,0.128l0.314,-0.153c0.006,-0.003 0.012,-0.007 0.018,-0.011Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.315,26.997c-0.017,-0.04 -0.05,-0.071 -0.092,-0.084l-0.5,-0.155l0.511,0.115c0.034,0.008 0.069,0.003 0.099,-0.013c-0.001,-0.001 -0.002,-0.002 -0.002,-0.003l-0.218,-0.269l0.239,0.251c0.002,0.002 0.004,0.004 0.006,0.006c0.001,-0.001 0.001,-0.001 0.002,-0.002c0.035,-0.029 0.056,-0.072 0.056,-0.117l-0.003,-0.527l0.045,0.525c0.003,0.038 0.021,0.073 0.049,0.098l0.188,-0.292l-0.166,0.308c-0,0 -0,0 -0,0c0.037,0.022 0.082,0.026 0.122,0.012l0.498,-0.171l-0.483,0.21c-0.038,0.017 -0.068,0.049 -0.082,0.088c0.002,0.001 0.004,0.001 0.006,0.002l0.336,0.087l-0.342,-0.06c-0.002,-0 -0.004,-0.001 -0.006,-0.001c-0.006,0.039 0.004,0.078 0.027,0.109l0.311,0.421l-0.344,-0.395c-0.026,-0.03 -0.064,-0.048 -0.103,-0.05c-0.001,0.006 -0.001,0.012 -0.001,0.018l0.018,0.348l-0.045,-0.346c-0.001,-0.006 -0.002,-0.013 -0.004,-0.019c-0.038,0.007 -0.073,0.029 -0.096,0.061l-0.306,0.431l0.271,-0.454c0.019,-0.031 0.025,-0.067 0.019,-0.102c-0.005,0.001 -0.011,0.003 -0.016,0.005l-0.324,0.128l0.314,-0.153c0.006,-0.003 0.012,-0.007 0.018,-0.011Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.689,28.643c0.016,-0.041 0.014,-0.086 -0.006,-0.125l-0.244,-0.464l0.28,0.443c0.018,0.029 0.046,0.051 0.079,0.061c0,-0.001 0,-0.003 0,-0.004l0.034,-0.348l-0.007,0.349c-0,0.003 0,0.006 0,0.009c0.001,0 0.002,0 0.003,0c0.045,0.004 0.09,-0.012 0.121,-0.045l0.366,-0.381l-0.335,0.408c-0.024,0.03 -0.036,0.067 -0.034,0.105l0.337,-0.077l-0.333,0.104c-0,0 -0,0 -0,0c0.011,0.042 0.039,0.076 0.078,0.095l0.47,0.229l-0.487,-0.191c-0.039,-0.015 -0.082,-0.013 -0.119,0.006c0.001,0.002 0.002,0.003 0.003,0.005l0.175,0.3l-0.199,-0.285c-0.001,-0.002 -0.002,-0.003 -0.004,-0.005c-0.031,0.024 -0.052,0.059 -0.057,0.098l-0.076,0.522l0.034,-0.526c0.003,-0.04 -0.011,-0.08 -0.038,-0.109c-0.005,0.004 -0.009,0.008 -0.013,0.012l-0.231,0.263l0.21,-0.28c0.004,-0.005 0.007,-0.011 0.01,-0.017c-0.032,-0.022 -0.071,-0.031 -0.11,-0.024l-0.517,0.094l0.509,-0.135c0.035,-0.009 0.065,-0.031 0.085,-0.06c-0.005,-0.003 -0.01,-0.006 -0.015,-0.008l-0.318,-0.137l0.328,0.111c0.007,0.002 0.013,0.004 0.02,0.005Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.975,32.49c-0.038,-0.008 -0.078,0.002 -0.109,0.026l-0.372,0.294l0.348,-0.323c0.023,-0.021 0.038,-0.05 0.042,-0.08c-0.001,0 -0.002,0 -0.003,0l-0.311,0.027l0.308,-0.052c0.003,-0 0.005,-0.001 0.008,-0.002c-0,-0.001 -0,-0.002 -0,-0.002c-0.003,-0.041 -0.024,-0.078 -0.058,-0.1l-0.39,-0.262l0.41,0.23c0.03,0.017 0.065,0.021 0.097,0.013l-0.118,-0.286l0.142,0.278c0,0 0,0 0,0c0.035,-0.016 0.061,-0.047 0.072,-0.085l0.131,-0.456l-0.095,0.464c-0.008,0.037 0.001,0.075 0.023,0.105c0.001,-0.001 0.003,-0.002 0.004,-0.003l0.237,-0.206l-0.22,0.224c-0.001,0.001 -0.003,0.003 -0.004,0.004c0.025,0.024 0.059,0.036 0.095,0.035l0.471,-0.02l-0.468,0.057c-0.036,0.004 -0.068,0.023 -0.09,0.052c0.004,0.004 0.008,0.007 0.013,0.01l0.266,0.161l-0.278,-0.14c-0.005,-0.003 -0.011,-0.005 -0.016,-0.006c-0.015,0.032 -0.017,0.069 -0.005,0.102l0.16,0.443l-0.195,-0.429c-0.013,-0.029 -0.037,-0.052 -0.065,-0.065c-0.002,0.005 -0.004,0.009 -0.005,0.014l-0.073,0.305l0.049,-0.31c0.001,-0.006 0.001,-0.013 0.001,-0.019Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", null, _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.618,31.75l3.428,-0.222l-0.596,3.418l-6.383,4.792l-1.803,-1.982l5.354,-6.006Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip19)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image20",
    x: 63.264,
    y: 31.528,
    width: "9px",
    height: "9px"
  }))), _clipPath0 || (_clipPath0 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.618,31.75l3.428,-0.222l-0.596,3.418l-6.383,4.792l-1.803,-1.982l5.354,-6.006Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.287,33.118c-1.829,2.232 1.03,5.651 1.346,6.028c-1.033,0.676 -3.776,3.641 -6.267,0.099c-1.268,-1.803 0.874,-3.044 3.398,-5.155c0.287,-0.24 1.493,-0.779 1.579,-0.776",
    style: {
      fill: "#0074ae",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.322,39.147c2.228,-0.764 4.732,-2.985 8.279,-5.26c1.224,-0.785 0.983,-0.218 0.039,1.127c-5.034,7.175 -7.152,5.584 -7.674,5.191c-0.988,-0.742 -1.282,-0.473 -1.195,-0.553",
    style: {
      fill: "#004a6f",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.596,31.852c0.241,0.01 0.572,0.349 0.647,0.38c-0.139,0.17 -0.262,0.158 -1.833,2.14c-1.146,1.445 0.146,0.165 0.472,-0.167c0.735,-0.749 1.646,-1.734 1.697,-1.742c0.059,-0.01 0.822,0.678 0.579,0.149c-0.023,-0.05 -0.294,-0.376 -0.294,-0.376l-0.252,-0.222c0,0 -0.537,-0.197 -0.947,-0.221",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.182,32.318c0.146,0.162 0.49,0.673 0.69,0.861c0.006,0.006 0.142,0.137 0.043,0.086c-0.212,-0.111 -0.952,-0.927 -0.862,-1.023c0.124,-0.133 1.393,-0.285 0.748,-0.125c-0.323,0.08 -0.323,0.064 -0.52,0.144c-0.033,0.013 -0.069,0.04 -0.099,0.058Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.835,31.721l-2.171,0.481c-0.015,0.008 -11.384,12.314 -3.049,3.102c2.912,-3.219 2.959,-3.26 2.985,-3.266c2.335,-0.543 2.48,-0.645 2.467,-0.445c-0.003,0.04 -0.739,2.342 -0.753,2.362c-0.027,0.039 -11.506,9.017 -5.064,3.835c3.996,-3.214 4.911,-3.933 4.914,-3.938c0.092,-0.163 0.059,-0.18 0.671,-2.131Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.832,36.773c-0.041,-0.172 -0.317,-1.305 -0.666,-2.813c-0.02,-0.088 -0.099,-0.088 -1.527,-1.7c-0.125,-0.142 -0.155,-0.1 -2.838,-1.016c2.805,0.782 2.811,0.767 2.857,0.812c0.066,0.063 1.07,1.148 1.621,1.784c0.05,0.058 0.028,0.068 0.552,2.934Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.606,31.56l3.428,-0.222c0.058,-0.004 0.115,0.019 0.154,0.063c0.039,0.043 0.056,0.102 0.046,0.159l-0.596,3.418c-0.008,0.048 -0.034,0.09 -0.073,0.119l-6.383,4.792c-0.078,0.059 -0.188,0.048 -0.254,-0.024l-1.803,-1.982c-0.065,-0.072 -0.066,-0.181 -0.001,-0.254l5.354,-6.006c0.033,-0.037 0.08,-0.06 0.129,-0.063Zm0.012,0.189l-5.354,6.006l1.803,1.982l6.383,-4.792l0.596,-3.418l-3.428,0.222Z",
    style: {
      fill: "#00ceff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.731,31.973c0.036,-0.069 0.04,-0.15 0.012,-0.222l-0.347,-0.864l0.414,0.833c0.027,0.055 0.073,0.098 0.128,0.122c0.001,-0.002 0.001,-0.005 0.002,-0.007l0.123,-0.608l-0.075,0.615c-0.001,0.005 -0.001,0.01 -0.001,0.015c0.002,0 0.003,0.001 0.005,0.001c0.079,0.016 0.16,-0.006 0.222,-0.058l0.713,-0.606l-0.664,0.661c-0.048,0.048 -0.076,0.112 -0.078,0.179l0.608,-0.076l-0.605,0.124c-0,0 -0,0 -0,0c0.011,0.075 0.055,0.142 0.12,0.182l0.788,0.489l-0.825,-0.424c-0.066,-0.034 -0.143,-0.038 -0.212,-0.012c0.001,0.003 0.003,0.006 0.004,0.009l0.256,0.561l-0.299,-0.538c-0.002,-0.003 -0.004,-0.006 -0.006,-0.01c-0.059,0.036 -0.102,0.094 -0.118,0.162l-0.226,0.909l0.154,-0.923c0.012,-0.071 -0.006,-0.142 -0.047,-0.199c-0.009,0.006 -0.017,0.012 -0.025,0.02l-0.454,0.423l0.42,-0.457c0.008,-0.009 0.015,-0.018 0.021,-0.027c-0.052,-0.045 -0.12,-0.068 -0.19,-0.062l-0.928,0.073l0.92,-0.146c0.063,-0.01 0.119,-0.042 0.16,-0.09c-0.008,-0.006 -0.016,-0.012 -0.025,-0.017l-0.536,-0.299l0.558,0.256c0.011,0.005 0.023,0.009 0.035,0.012Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.999,36.2c0.02,-0.039 0.023,-0.084 0.006,-0.125l-0.196,-0.487l0.234,0.47c0.015,0.031 0.041,0.055 0.072,0.069c0,-0.001 0.001,-0.003 0.001,-0.004l0.069,-0.343l-0.042,0.347c-0,0.003 -0.001,0.006 -0.001,0.009c0.001,0 0.002,0 0.003,0.001c0.044,0.009 0.09,-0.003 0.125,-0.033l0.402,-0.342l-0.375,0.373c-0.027,0.027 -0.043,0.063 -0.044,0.101l0.343,-0.043l-0.341,0.07c-0,0 -0,0 -0,0c0.006,0.043 0.031,0.08 0.068,0.103l0.445,0.276l-0.465,-0.239c-0.037,-0.019 -0.08,-0.021 -0.119,-0.007c0.001,0.002 0.001,0.004 0.002,0.005l0.144,0.316l-0.169,-0.304c-0.001,-0.002 -0.002,-0.004 -0.003,-0.005c-0.033,0.02 -0.057,0.053 -0.067,0.092l-0.128,0.512l0.087,-0.521c0.007,-0.04 -0.003,-0.08 -0.027,-0.112c-0.005,0.003 -0.01,0.007 -0.014,0.011l-0.256,0.238l0.237,-0.258c0.004,-0.005 0.008,-0.01 0.012,-0.015c-0.029,-0.025 -0.068,-0.038 -0.107,-0.035l-0.523,0.041l0.519,-0.082c0.035,-0.006 0.067,-0.024 0.09,-0.051c-0.004,-0.003 -0.009,-0.007 -0.014,-0.009l-0.302,-0.169l0.315,0.144c0.006,0.003 0.013,0.005 0.02,0.007Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.753,31.652c0.02,-0.039 0.023,-0.084 0.006,-0.125l-0.196,-0.487l0.234,0.47c0.015,0.031 0.041,0.055 0.072,0.069c0,-0.001 0.001,-0.003 0.001,-0.004l0.069,-0.343l-0.042,0.347c-0,0.003 -0.001,0.006 -0.001,0.009c0.001,0 0.002,0 0.003,0.001c0.044,0.009 0.09,-0.003 0.125,-0.033l0.402,-0.342l-0.375,0.373c-0.027,0.027 -0.043,0.063 -0.044,0.101l0.343,-0.043l-0.341,0.07c-0,0 -0,0 -0,0c0.006,0.043 0.031,0.08 0.068,0.103l0.445,0.276l-0.465,-0.239c-0.037,-0.019 -0.08,-0.021 -0.119,-0.007c0.001,0.002 0.001,0.004 0.002,0.005l0.144,0.316l-0.169,-0.304c-0.001,-0.002 -0.002,-0.004 -0.003,-0.005c-0.033,0.02 -0.057,0.053 -0.067,0.092l-0.128,0.512l0.087,-0.521c0.007,-0.04 -0.003,-0.08 -0.027,-0.112c-0.005,0.003 -0.01,0.007 -0.014,0.011l-0.256,0.238l0.237,-0.258c0.004,-0.005 0.008,-0.01 0.012,-0.015c-0.029,-0.025 -0.068,-0.038 -0.107,-0.035l-0.523,0.041l0.519,-0.082c0.035,-0.006 0.067,-0.024 0.09,-0.051c-0.004,-0.003 -0.009,-0.007 -0.014,-0.009l-0.302,-0.169l0.315,0.144c0.006,0.003 0.013,0.005 0.02,0.007Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.527,33.878c0.041,-0.013 0.075,-0.045 0.092,-0.085l0.203,-0.488l-0.164,0.502c-0.011,0.033 -0.01,0.069 0.003,0.1c0.001,-0.001 0.002,-0.001 0.003,-0.002l0.288,-0.197l-0.272,0.219c-0.002,0.002 -0.004,0.004 -0.006,0.006c0,0.001 0.001,0.001 0.001,0.002c0.025,0.038 0.066,0.062 0.111,0.065l0.523,0.038l-0.525,0.003c-0.038,0 -0.075,0.015 -0.102,0.041l0.271,0.211l-0.289,-0.19c-0,-0 -0,-0 -0,-0c-0.025,0.035 -0.034,0.079 -0.024,0.122l0.12,0.512l-0.16,-0.5c-0.013,-0.04 -0.042,-0.072 -0.079,-0.089c-0.001,0.002 -0.001,0.004 -0.002,0.005l-0.12,0.329l0.093,-0.337c0.001,-0.002 0.001,-0.004 0.002,-0.006c-0.038,-0.009 -0.078,-0.002 -0.111,0.019l-0.448,0.278l0.426,-0.312c0.033,-0.024 0.054,-0.06 0.06,-0.099c-0.006,-0.001 -0.012,-0.002 -0.018,-0.002l-0.347,-0.01l0.347,-0.018c0.006,-0 0.013,-0.001 0.019,-0.003c-0.003,-0.039 -0.021,-0.075 -0.051,-0.101l-0.398,-0.34l0.423,0.307c0.029,0.021 0.064,0.03 0.099,0.027c-0.001,-0.006 -0.002,-0.011 -0.003,-0.016l-0.095,-0.335l0.121,0.326c0.002,0.007 0.006,0.013 0.009,0.019Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.866,34.254c-0.018,-0.035 -0.05,-0.059 -0.089,-0.067l-0.46,-0.099l0.466,0.062c0.031,0.004 0.062,-0.003 0.088,-0.019c-0.001,-0.001 -0.002,-0.002 -0.002,-0.003l-0.217,-0.223l0.234,0.205c0.002,0.002 0.004,0.003 0.006,0.005c0.001,-0.001 0.001,-0.001 0.002,-0.002c0.029,-0.028 0.044,-0.069 0.04,-0.109l-0.045,-0.471l0.082,0.465c0.006,0.034 0.025,0.064 0.052,0.084l0.145,-0.276l-0.124,0.289c-0,0 -0,0 -0,0c0.035,0.017 0.075,0.017 0.111,0.001l0.432,-0.192l-0.416,0.226c-0.033,0.018 -0.057,0.049 -0.066,0.085c0.002,0 0.003,0.001 0.005,0.001l0.307,0.051l-0.311,-0.027c-0.002,-0 -0.004,-0 -0.006,-0c-0.002,0.035 0.01,0.069 0.033,0.096l0.312,0.352l-0.339,-0.326c-0.026,-0.025 -0.061,-0.038 -0.096,-0.036c-0,0.005 0,0.011 0.001,0.016l0.044,0.31l-0.068,-0.305c-0.001,-0.006 -0.003,-0.011 -0.005,-0.016c-0.034,0.009 -0.063,0.031 -0.081,0.062l-0.24,0.41l0.207,-0.427c0.014,-0.029 0.017,-0.062 0.009,-0.093c-0.005,0.001 -0.009,0.003 -0.014,0.006l-0.28,0.14l0.269,-0.162c0.005,-0.003 0.01,-0.007 0.015,-0.011Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }))), /*#__PURE__*/React.createElement("g", null, _clipPath1 || (_clipPath1 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.318,34.466l5.497,1.328l-3.776,4.281l-4.268,-0.451l-1.229,-0.877l3.776,-4.281Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip22)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image23",
    x: 59.541,
    y: 34.466,
    width: "10px",
    height: "6px"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M63.318,34.466l5.497,1.328l-3.776,4.281l-4.268,-0.451l-1.229,-0.877l3.776,-4.281Z",
    style: {
      fill: "none",
      stroke: "#59bdff",
      strokeWidth: "0.08px"
    }
  }), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.815,35.794l-9.274,2.952l0.311,-1.221l3.465,-3.06l1.721,5.609"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip24)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image25",
    x: 59.541,
    y: 34.466,
    width: "10px",
    height: "6px"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.815,35.794l-9.274,2.952l0.311,-1.221l3.465,-3.06l1.721,5.609",
    style: {
      fill: "none",
      stroke: "#56c9ff",
      strokeWidth: "0.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.731,35.815l2.851,0.679l-1.964,2.212l-4.193,-0.229l3.306,-2.661Z",
    style: {
      fill: "#78f8ff"
    }
  }), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.731,35.815l2.851,0.679l-1.964,2.212l-4.193,-0.229l3.306,-2.661Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.061,35.215l-1.536,3.737l-0.267,-0.164l1.326,-3.673l0.477,0.1Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.289,35.282l-1.296,3.692l-0.109,-0.021l1.343,-3.662l0.062,-0.009Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.731,35.815l2.851,0.679l-1.964,2.212l-4.193,-0.229l3.306,-2.661Z",
    style: {
      fill: "none",
      stroke: "#59bcff",
      strokeWidth: "0.08px"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.693,46.102l-0.22,-5.702l5.619,1.14l7.639,10.811l-3.349,2.907l-9.689,-9.155Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.96
    }
  }), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.693,46.102l-0.22,-5.702l5.619,1.14l7.639,10.811l-3.349,2.907l-9.689,-9.155Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.896,48.372c3.608,3.136 9.374,-1.461 10.011,-1.968c1.073,1.745 5.85,6.431 -0.105,10.411c-3.031,2.026 -4.989,-1.585 -8.367,-5.869c-0.384,-0.487 -1.223,-2.514 -1.214,-2.655",
    style: {
      fill: "#0074ae",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.724,53.562c-1.166,-3.733 -4.726,-7.989 -8.331,-13.98c-1.244,-2.067 -0.317,-1.642 1.863,-0.016c11.632,8.675 8.914,12.122 8.244,12.972c-1.268,1.608 -0.835,2.107 -0.964,1.959",
    style: {
      fill: "#004a6f",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.862,46.143c0.026,-0.4 0.6,-0.935 0.655,-1.057c0.275,0.239 0.25,0.442 3.455,3.138c2.338,1.967 0.279,-0.236 -0.255,-0.79c-1.206,-1.253 -2.793,-2.809 -2.804,-2.895c-0.013,-0.099 1.155,-1.336 0.271,-0.954c-0.084,0.036 -0.633,0.472 -0.633,0.472l-0.377,0.408c0,0 -0.349,0.884 -0.406,1.562",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.675,43.525c0.289,-0.199 1.284,-0.89 1.509,-1.14c0.722,-0.802 -0.262,0.632 -1.433,1.332c-0.049,0.029 -0.124,0.072 -0.179,0.029c-0.18,-0.14 -0.298,-1.437 -0.299,-1.477c-0.007,-0.565 0.063,0.375 0.402,1.256Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.783,40.757l0.701,3.627c0.003,0.006 2.553,2.495 9.969,9.832c0.017,0.017 0.104,0.077 0.058,0.125c-0.085,0.087 -0.094,-0.022 -1.519,-1.388c-7.286,-6.981 -8.769,-8.41 -8.781,-8.47c-0.786,-3.901 -0.931,-4.17 -0.604,-4.113c0.02,0.004 3.803,1.323 3.843,1.353c0.072,0.053 8.382,11.397 8.385,11.408c0.002,0.007 -0.002,0.154 -0.077,0.058c-1.205,-1.546 -7.307,-9.656 -7.94,-10.497c-0.182,-0.242 -0.286,-0.57 -0.545,-0.727c-0.264,-0.16 -0.294,-0.105 -3.49,-1.208Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.124,40.987c-0.324,0.068 -2.146,0.464 -4.683,0.982c-0.147,0.03 -0.091,0.118 -2.871,2.465c-0.293,0.247 -0.201,0.309 -0.71,1.712c-0.44,1.213 -0.893,2.439 -1.08,2.947c1.41,-4.622 1.387,-4.639 1.461,-4.707c1.104,-1.007 2.771,-2.407 3.015,-2.613c0.094,-0.079 0.109,-0.042 4.867,-0.787Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.194,46.159l-0.22,-5.702c-0.018,-0.46 0.177,-0.903 0.527,-1.201c0.351,-0.298 0.819,-0.419 1.27,-0.327l5.619,1.14c0.375,0.076 0.706,0.292 0.927,0.604l7.639,10.811c0.445,0.629 0.34,1.493 -0.242,1.998l-3.349,2.907c-0.582,0.505 -1.453,0.487 -2.013,-0.043l-9.689,-9.155c-0.285,-0.27 -0.454,-0.64 -0.469,-1.032Zm1.499,-0.058l9.689,9.155l3.349,-2.907l-7.639,-10.811l-5.619,-1.14l0.22,5.702Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.939,54.672l-2.075,-2.768l3.155,-1.375l7.483,2.75l-0.644,2.608l-7.92,-1.215Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.96
    }
  }), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.939,54.672l-2.075,-2.768l3.155,-1.375l7.483,2.75l-0.644,2.608l-7.92,-1.215Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.805,55.042c2.855,0.316 4.104,-3.971 4.242,-4.445c1.129,0.499 5.094,1.184 3.539,5.229c-0.791,2.059 -2.999,0.935 -6.137,-0.033c-0.357,-0.11 -1.468,-0.831 -1.512,-0.905",
    style: {
      fill: "#0074ae",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.426,54.231c-1.86,-1.459 -5.078,-2.35 -8.917,-4.091c-1.324,-0.601 -0.722,-0.709 0.91,-0.652c8.71,0.304 8.563,2.962 8.526,3.619c-0.069,1.241 0.316,1.34 0.202,1.311",
    style: {
      fill: "#fff",
      fillOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.036,54.634c-0.125,-0.209 -0.028,-0.674 -0.043,-0.754c0.217,0.024 0.275,0.134 2.78,0.37c1.827,0.172 0.056,-0.214 -0.398,-0.306c-1.025,-0.208 -2.342,-0.435 -2.377,-0.474c-0.041,-0.045 0.107,-1.066 -0.196,-0.57c-0.029,0.047 -0.148,0.454 -0.148,0.454l-0.045,0.334c0,0 0.133,0.561 0.339,0.92",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.546,53.042c0.053,-0.212 0.286,-0.782 0.331,-1.054c0.001,-0.008 0.035,-0.195 0.047,-0.084c0.025,0.238 -0.241,1.311 -0.371,1.288c-0.178,-0.031 -1.004,-1.016 -0.515,-0.561c0.245,0.228 0.232,0.238 0.406,0.359c0.029,0.02 0.07,0.036 0.102,0.052Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.139,51.974l1.597,1.568c0.014,0.008 16.469,2.835 4.24,0.864c-4.243,-0.684 -4.322,-0.703 -4.341,-0.722c-1.736,-1.668 -1.903,-1.729 -1.73,-1.832c0.037,-0.022 2.348,-0.664 2.371,-0.664c0.048,0.001 13.798,4.746 5.965,2.161c-4.869,-1.607 -5.964,-1.982 -5.97,-1.981c-0.185,0.011 -0.181,0.049 -2.133,0.605Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.319,49.204c-0.171,0.184 -0.875,0.952 -1.973,2.119c-0.04,0.042 -0.016,0.165 -0.554,2.224c-0.037,0.141 0.001,0.143 0.729,2.933c-0.901,-2.792 -0.917,-2.788 -0.906,-2.853c0.013,-0.076 0.353,-1.506 0.581,-2.346c0.019,-0.07 0.038,-0.057 2.122,-2.077Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.739,55.572l-2.075,-2.768c-0.275,-0.367 -0.367,-0.839 -0.25,-1.283c0.117,-0.443 0.431,-0.809 0.851,-0.992l3.155,-1.375c0.354,-0.154 0.754,-0.166 1.117,-0.033l7.483,2.75c0.718,0.264 1.122,1.025 0.939,1.767l-0.644,2.608c-0.186,0.754 -0.916,1.241 -1.684,1.123l-7.92,-1.215c-0.388,-0.06 -0.737,-0.269 -0.973,-0.583Zm1.2,-0.9l7.92,1.215l0.644,-2.608l-7.483,-2.75l-3.155,1.375l2.075,2.768Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M62.802,46.294l0.793,-3.343l3.094,1.572l2.709,7.507l-2.423,1.143l-4.172,-6.88Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.96
    }
  }), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.802,46.294l0.793,-3.343l3.094,1.572l2.709,7.507l-2.423,1.143l-4.172,-6.88Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.721,47.967c1.598,2.403 5.704,0.672 6.158,0.481c0.344,1.186 2.373,4.678 -1.743,6.021c-2.096,0.684 -2.654,-1.728 -3.932,-4.76c-0.145,-0.345 -0.307,-1.656 -0.279,-1.737",
    style: {
      fill: "#0074ae",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.615,52.57c-0.077,-2.354 -1.466,-5.399 -2.601,-9.458c-0.392,-1.4 0.08,-1.004 1.089,0.293c5.383,6.916 3.241,8.475 2.713,8.859c-1,0.727 -0.828,1.087 -0.879,0.98",
    style: {
      fill: "#004a6f",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.894,46.345c0.08,-0.228 0.501,-0.445 0.553,-0.507c0.122,0.183 0.074,0.297 1.508,2.38c1.046,1.519 0.201,-0.091 -0.021,-0.5c-0.501,-0.922 -1.175,-2.082 -1.168,-2.133c0.008,-0.06 0.89,-0.587 0.312,-0.509c-0.055,0.007 -0.445,0.171 -0.445,0.171l-0.286,0.176c0,0 -0.346,0.456 -0.489,0.84",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.804,44.965c0.198,-0.092 0.787,-0.271 1.026,-0.407c0.007,-0.004 0.173,-0.095 0.094,-0.016c-0.168,0.17 -1.166,0.638 -1.231,0.524c-0.09,-0.157 0.136,-1.415 0.1,-0.751c-0.018,0.332 -0.034,0.328 -0.015,0.539c0.003,0.035 0.018,0.077 0.026,0.112Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.719,43.209l-0.177,2.216c0.003,0.017 8.434,14.495 2.072,3.825c-2.223,-3.728 -2.249,-3.785 -2.247,-3.811c0.165,-2.392 0.111,-2.56 0.298,-2.489c0.038,0.014 2.022,1.394 2.037,1.413c0.03,0.038 5.246,13.644 2.182,5.966c-1.901,-4.763 -2.32,-5.849 -2.324,-5.853c-0.129,-0.136 -0.155,-0.109 -1.841,-1.266Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.548,44.694c-0.177,-0.011 -1.34,-0.08 -2.885,-0.188c-0.09,-0.006 -0.113,0.069 -2.073,0.961c-0.172,0.078 -0.141,0.118 -1.804,2.415c1.57,-2.452 1.557,-2.462 1.614,-2.494c0.08,-0.044 1.412,-0.686 2.181,-1.027c0.07,-0.031 0.073,-0.007 2.967,0.333Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.343,45.947l0.793,-3.343c0.106,-0.447 0.412,-0.821 0.829,-1.015c0.417,-0.193 0.9,-0.185 1.31,0.024l3.094,1.572c0.34,0.173 0.602,0.469 0.731,0.828l2.709,7.507c0.263,0.728 -0.071,1.536 -0.771,1.866l-2.423,1.143c-0.695,0.328 -1.524,0.078 -1.922,-0.579l-4.172,-6.88c-0.204,-0.337 -0.268,-0.741 -0.177,-1.124Zm1.459,0.346l4.172,6.88l2.423,-1.143l-2.709,-7.507l-3.094,-1.572l-0.793,3.343Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.845,52.157l2.882,-4.866l2.985,4.866l-1.683,3.948l-1.199,0.918l-2.985,-4.866Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.96,
      stroke: "#fff",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.727,47.291l0.103,9.732l-1.076,-0.656l-1.909,-4.21l5.867,-0.001",
    style: {
      fill: "#fff",
      fillOpacity: 0.96,
      stroke: "#fff",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.256,52.157l1.485,-2.526l1.538,2.526l-1.449,3.941l-1.575,-3.941Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.96
    }
  }), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.256,52.157l1.485,-2.526l1.538,2.526l-1.449,3.941l-1.575,-3.941Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.073,50.71l3.123,2.564l-0.235,0.207l-3.123,-2.345l0.235,-0.427Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.203,50.513l3.15,2.322l-0.052,0.098l-3.107,-2.357l0.009,-0.062Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.256,52.157l1.485,-2.526l1.538,2.526l-1.449,3.941l-1.575,-3.941Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "1.5px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _clipPath16 || (_clipPath16 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.693,46.102l-0.22,-5.702l5.619,1.14l7.639,10.811l-3.349,2.907l-9.689,-9.155Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip31)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image32",
    x: 55.473,
    y: 40.399,
    width: "14px",
    height: "15px"
  }))), _clipPath17 || (_clipPath17 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.693,46.102l-0.22,-5.702l5.619,1.14l7.639,10.811l-3.349,2.907l-9.689,-9.155Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.896,48.372c3.608,3.136 9.374,-1.461 10.011,-1.968c1.073,1.745 5.85,6.431 -0.105,10.411c-3.031,2.026 -4.989,-1.585 -8.367,-5.869c-0.384,-0.487 -1.223,-2.514 -1.214,-2.655",
    style: {
      fill: "#0074ae",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.724,53.562c-1.166,-3.733 -4.726,-7.989 -8.331,-13.98c-1.244,-2.067 -0.317,-1.642 1.863,-0.016c11.632,8.675 8.914,12.122 8.244,12.972c-1.268,1.608 -0.835,2.107 -0.964,1.959",
    style: {
      fill: "#004a6f",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.862,46.143c0.026,-0.4 0.6,-0.935 0.655,-1.057c0.275,0.239 0.25,0.442 3.455,3.138c2.338,1.967 0.279,-0.236 -0.255,-0.79c-1.206,-1.253 -2.793,-2.809 -2.804,-2.895c-0.013,-0.099 1.155,-1.336 0.271,-0.954c-0.084,0.036 -0.633,0.472 -0.633,0.472l-0.377,0.408c0,0 -0.349,0.884 -0.406,1.562",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.675,43.525c0.289,-0.199 1.284,-0.89 1.509,-1.14c0.722,-0.802 -0.262,0.632 -1.433,1.332c-0.049,0.029 -0.124,0.072 -0.179,0.029c-0.18,-0.14 -0.298,-1.437 -0.299,-1.477c-0.007,-0.565 0.063,0.375 0.402,1.256Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.783,40.757l0.701,3.627c0.003,0.006 2.553,2.495 9.969,9.832c0.017,0.017 0.104,0.077 0.058,0.125c-0.085,0.087 -0.094,-0.022 -1.519,-1.388c-7.286,-6.981 -8.769,-8.41 -8.781,-8.47c-0.786,-3.901 -0.931,-4.17 -0.604,-4.113c0.02,0.004 3.803,1.323 3.843,1.353c0.072,0.053 8.382,11.397 8.385,11.408c0.002,0.007 -0.002,0.154 -0.077,0.058c-1.205,-1.546 -7.307,-9.656 -7.94,-10.497c-0.182,-0.242 -0.286,-0.57 -0.545,-0.727c-0.264,-0.16 -0.294,-0.105 -3.49,-1.208Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.124,40.987c-0.324,0.068 -2.146,0.464 -4.683,0.982c-0.147,0.03 -0.091,0.118 -2.871,2.465c-0.293,0.247 -0.201,0.309 -0.71,1.712c-0.44,1.213 -0.893,2.439 -1.08,2.947c1.41,-4.622 1.387,-4.639 1.461,-4.707c1.104,-1.007 2.771,-2.407 3.015,-2.613c0.094,-0.079 0.109,-0.042 4.867,-0.787Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.38,46.114l-0.22,-5.702c-0.004,-0.096 0.037,-0.189 0.11,-0.251c0.073,-0.062 0.171,-0.088 0.266,-0.068l5.619,1.14c0.078,0.016 0.148,0.061 0.194,0.126l7.639,10.811c0.093,0.132 0.071,0.312 -0.051,0.418l-3.349,2.907c-0.122,0.106 -0.304,0.102 -0.421,-0.009l-9.689,-9.155c-0.06,-0.056 -0.095,-0.134 -0.098,-0.216Zm0.313,-0.012l9.689,9.155l3.349,-2.907l-7.639,-10.811l-5.619,-1.14l0.22,5.702Z",
    style: {
      fill: "#00ceff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.081,45.083c-0.112,-0.063 -0.246,-0.074 -0.365,-0.029l-1.441,0.538l1.393,-0.651c0.092,-0.043 0.165,-0.117 0.207,-0.207c-0.004,-0.001 -0.007,-0.002 -0.011,-0.003l-0.998,-0.231l1.012,0.151c0.008,0.001 0.017,0.002 0.025,0.003c0.001,-0.002 0.001,-0.005 0.002,-0.007c0.029,-0.13 -0.002,-0.266 -0.086,-0.371l-0.971,-1.211l1.063,1.132c0.077,0.082 0.182,0.131 0.293,0.138l-0.099,-1.012l0.18,1.009c0,0 0,0 0,0c0.125,-0.016 0.237,-0.085 0.306,-0.191l0.841,-1.287l-0.736,1.351c-0.059,0.108 -0.069,0.235 -0.028,0.351c0.005,-0.002 0.011,-0.004 0.016,-0.006l0.937,-0.4l-0.901,0.473c-0.005,0.003 -0.011,0.006 -0.016,0.009c0.057,0.099 0.152,0.173 0.263,0.204l1.491,0.416l-1.517,-0.297c-0.116,-0.023 -0.235,0.003 -0.331,0.07c0.009,0.015 0.019,0.029 0.031,0.043l0.678,0.773l-0.737,-0.717c-0.014,-0.013 -0.029,-0.025 -0.044,-0.035c-0.077,0.084 -0.117,0.197 -0.111,0.313l0.08,1.544l-0.202,-1.534c-0.014,-0.105 -0.065,-0.2 -0.142,-0.27c-0.011,0.012 -0.02,0.026 -0.029,0.04l-0.517,0.877l0.446,-0.916c0.009,-0.019 0.016,-0.038 0.021,-0.058Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.014,47.326c-0.063,-0.035 -0.139,-0.042 -0.206,-0.016l-0.813,0.304l0.785,-0.367c0.052,-0.024 0.093,-0.066 0.117,-0.117c-0.002,-0.001 -0.004,-0.001 -0.006,-0.002l-0.563,-0.13l0.571,0.085c0.005,0.001 0.009,0.001 0.014,0.001c0,-0.001 0.001,-0.003 0.001,-0.004c0.017,-0.073 -0.001,-0.15 -0.049,-0.209l-0.548,-0.683l0.599,0.638c0.044,0.046 0.103,0.074 0.165,0.078l-0.056,-0.571l0.101,0.569c0,0 0,0 0,0c0.071,-0.009 0.134,-0.048 0.173,-0.108l0.474,-0.726l-0.415,0.762c-0.033,0.061 -0.039,0.133 -0.016,0.198c0.003,-0.001 0.006,-0.002 0.009,-0.003l0.528,-0.225l-0.508,0.267c-0.003,0.002 -0.006,0.003 -0.009,0.005c0.032,0.056 0.085,0.097 0.148,0.115l0.841,0.235l-0.856,-0.168c-0.066,-0.013 -0.133,0.002 -0.187,0.039c0.005,0.009 0.011,0.017 0.018,0.024l0.383,0.436l-0.415,-0.404c-0.008,-0.008 -0.016,-0.014 -0.025,-0.02c-0.043,0.048 -0.066,0.111 -0.063,0.176l0.045,0.871l-0.114,-0.865c-0.008,-0.059 -0.037,-0.113 -0.08,-0.152c-0.006,0.007 -0.011,0.015 -0.016,0.023l-0.292,0.495l0.252,-0.517c0.005,-0.01 0.009,-0.021 0.012,-0.033Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.622,42.553c-0.063,-0.035 -0.139,-0.042 -0.206,-0.016l-0.813,0.304l0.785,-0.367c0.052,-0.024 0.093,-0.066 0.117,-0.117c-0.002,-0.001 -0.004,-0.001 -0.006,-0.002l-0.563,-0.13l0.571,0.085c0.005,0.001 0.009,0.001 0.014,0.001c0,-0.001 0.001,-0.003 0.001,-0.004c0.017,-0.073 -0.001,-0.15 -0.049,-0.209l-0.548,-0.683l0.599,0.638c0.044,0.046 0.103,0.074 0.165,0.078l-0.056,-0.571l0.101,0.569c0,0 0,0 0,0c0.071,-0.009 0.134,-0.048 0.173,-0.108l0.474,-0.726l-0.415,0.762c-0.033,0.061 -0.039,0.133 -0.016,0.198c0.003,-0.001 0.006,-0.002 0.009,-0.003l0.528,-0.225l-0.508,0.267c-0.003,0.002 -0.006,0.003 -0.009,0.005c0.032,0.056 0.085,0.097 0.148,0.115l0.841,0.235l-0.856,-0.168c-0.066,-0.013 -0.133,0.002 -0.187,0.039c0.005,0.009 0.011,0.017 0.018,0.024l0.383,0.436l-0.415,-0.404c-0.008,-0.008 -0.016,-0.014 -0.025,-0.02c-0.043,0.048 -0.066,0.111 -0.063,0.176l0.045,0.871l-0.114,-0.865c-0.008,-0.059 -0.037,-0.113 -0.08,-0.152c-0.006,0.007 -0.011,0.015 -0.016,0.023l-0.292,0.495l0.252,-0.517c0.005,-0.01 0.009,-0.021 0.012,-0.033Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.331,41.366c-0.02,-0.069 -0.07,-0.127 -0.137,-0.157l-0.797,-0.358l0.822,0.294c0.054,0.019 0.113,0.019 0.166,-0c-0.001,-0.002 -0.002,-0.004 -0.003,-0.006l-0.313,-0.488l0.351,0.462c0.003,0.004 0.006,0.007 0.009,0.011c0.001,-0.001 0.002,-0.002 0.004,-0.002c0.063,-0.04 0.104,-0.107 0.112,-0.181l0.086,-0.867l-0.017,0.871c-0.001,0.063 0.022,0.124 0.064,0.171l0.361,-0.441l-0.327,0.472c-0,0 -0,0 -0,0c0.057,0.043 0.13,0.06 0.2,0.046l0.85,-0.177l-0.833,0.244c-0.066,0.019 -0.121,0.066 -0.15,0.128c0.003,0.001 0.006,0.003 0.009,0.004l0.538,0.213l-0.553,-0.17c-0.003,-0.001 -0.007,-0.002 -0.01,-0.003c-0.016,0.062 -0.007,0.129 0.026,0.185l0.44,0.757l-0.498,-0.72c-0.038,-0.055 -0.097,-0.092 -0.162,-0.104c-0.002,0.01 -0.004,0.019 -0.004,0.029l-0.031,0.576l-0.015,-0.577c-0,-0.011 -0.002,-0.021 -0.004,-0.032c-0.064,0.003 -0.125,0.032 -0.169,0.08l-0.579,0.645l0.525,-0.69c0.036,-0.047 0.053,-0.105 0.049,-0.164c-0.009,0.001 -0.018,0.002 -0.027,0.005l-0.557,0.143l0.543,-0.187c0.011,-0.004 0.022,-0.009 0.031,-0.015Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.753,49.121c-0.058,0.028 -0.1,0.081 -0.115,0.144l-0.182,0.759l0.122,-0.772c0.008,-0.051 -0.002,-0.103 -0.028,-0.147c-0.001,0.001 -0.003,0.003 -0.004,0.004l-0.378,0.35l0.349,-0.379c0.003,-0.003 0.006,-0.006 0.008,-0.01c-0.001,-0.001 -0.002,-0.002 -0.003,-0.003c-0.046,-0.05 -0.112,-0.077 -0.179,-0.072l-0.779,0.053l0.772,-0.115c0.056,-0.008 0.106,-0.038 0.14,-0.082l-0.45,-0.253l0.471,0.219c0,0 0,0 0,0c0.029,-0.057 0.031,-0.124 0.007,-0.184l-0.299,-0.726l0.355,0.701c0.028,0.056 0.079,0.097 0.138,0.114c0.001,-0.003 0.001,-0.006 0.002,-0.008l0.098,-0.508l-0.057,0.514c-0,0.003 -0.001,0.006 -0.001,0.009c0.058,0.005 0.115,-0.013 0.159,-0.051l0.594,-0.502l-0.552,0.548c-0.042,0.042 -0.065,0.099 -0.064,0.159c0.009,0.001 0.018,0 0.027,-0.001l0.513,-0.059l-0.507,0.099c-0.009,0.002 -0.019,0.005 -0.027,0.008c0.014,0.057 0.049,0.106 0.099,0.137l0.666,0.416l-0.697,-0.362c-0.048,-0.025 -0.102,-0.031 -0.153,-0.019c0.002,0.008 0.005,0.016 0.009,0.024l0.22,0.472l-0.256,-0.453c-0.005,-0.009 -0.011,-0.018 -0.018,-0.025Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", null, _clipPath18 || (_clipPath18 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.939,54.672l-2.075,-2.768l3.155,-1.375l7.483,2.75l-0.644,2.608l-7.92,-1.215Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip34)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image35",
    x: 55.864,
    y: 50.529,
    width: "11px",
    height: "6px"
  }))), _clipPath19 || (_clipPath19 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.939,54.672l-2.075,-2.768l3.155,-1.375l7.483,2.75l-0.644,2.608l-7.92,-1.215Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.805,55.042c2.855,0.316 4.104,-3.971 4.242,-4.445c1.129,0.499 5.094,1.184 3.539,5.229c-0.791,2.059 -2.999,0.935 -6.137,-0.033c-0.357,-0.11 -1.468,-0.831 -1.512,-0.905",
    style: {
      fill: "#0074ae",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.426,54.231c-1.86,-1.459 -5.078,-2.35 -8.917,-4.091c-1.324,-0.601 -0.722,-0.709 0.91,-0.652c8.71,0.304 8.563,2.962 8.526,3.619c-0.069,1.241 0.316,1.34 0.202,1.311",
    style: {
      fill: "#fff",
      fillOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.036,54.634c-0.125,-0.209 -0.028,-0.674 -0.043,-0.754c0.217,0.024 0.275,0.134 2.78,0.37c1.827,0.172 0.056,-0.214 -0.398,-0.306c-1.025,-0.208 -2.342,-0.435 -2.377,-0.474c-0.041,-0.045 0.107,-1.066 -0.196,-0.57c-0.029,0.047 -0.148,0.454 -0.148,0.454l-0.045,0.334c0,0 0.133,0.561 0.339,0.92",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.546,53.042c0.053,-0.212 0.286,-0.782 0.331,-1.054c0.001,-0.008 0.035,-0.195 0.047,-0.084c0.025,0.238 -0.241,1.311 -0.371,1.288c-0.178,-0.031 -1.004,-1.016 -0.515,-0.561c0.245,0.228 0.232,0.238 0.406,0.359c0.029,0.02 0.07,0.036 0.102,0.052Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.139,51.974l1.597,1.568c0.014,0.008 16.469,2.835 4.24,0.864c-4.243,-0.684 -4.322,-0.703 -4.341,-0.722c-1.736,-1.668 -1.903,-1.729 -1.73,-1.832c0.037,-0.022 2.348,-0.664 2.371,-0.664c0.048,0.001 13.798,4.746 5.965,2.161c-4.869,-1.607 -5.964,-1.982 -5.97,-1.981c-0.185,0.011 -0.181,0.049 -2.133,0.605Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.319,49.204c-0.171,0.184 -0.875,0.952 -1.973,2.119c-0.04,0.042 -0.016,0.165 -0.554,2.224c-0.037,0.141 0.001,0.143 0.729,2.933c-0.901,-2.792 -0.917,-2.788 -0.906,-2.853c0.013,-0.076 0.353,-1.506 0.581,-2.346c0.019,-0.07 0.038,-0.057 2.122,-2.077Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.788,54.785l-2.075,-2.768c-0.035,-0.046 -0.046,-0.105 -0.031,-0.161c0.015,-0.056 0.054,-0.101 0.107,-0.124l3.155,-1.375c0.044,-0.019 0.095,-0.021 0.14,-0.004l7.483,2.75c0.09,0.033 0.141,0.129 0.118,0.222l-0.644,2.608c-0.023,0.095 -0.115,0.156 -0.211,0.141l-7.92,-1.215c-0.049,-0.007 -0.093,-0.034 -0.122,-0.073Zm0.151,-0.113l7.92,1.215l0.644,-2.608l-7.483,-2.75l-3.155,1.375l2.075,2.768Z",
    style: {
      fill: "#00ceff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.27,53.684c-0.077,0.007 -0.146,0.048 -0.19,0.112l-0.523,0.767l0.46,-0.807c0.03,-0.053 0.041,-0.115 0.03,-0.175c-0.002,0.001 -0.004,0.002 -0.006,0.002l-0.57,0.23l0.55,-0.275c0.005,-0.002 0.009,-0.005 0.013,-0.007c-0.001,-0.001 -0.001,-0.003 -0.002,-0.004c-0.03,-0.075 -0.093,-0.132 -0.17,-0.155l-0.895,-0.268l0.913,0.197c0.066,0.014 0.135,0.002 0.192,-0.032l-0.398,-0.471l0.436,0.441c0,0 0,0 0,0c0.056,-0.051 0.087,-0.124 0.085,-0.201l-0.031,-0.933l0.104,0.928c0.008,0.074 0.047,0.141 0.107,0.185c0.002,-0.003 0.004,-0.006 0.006,-0.009l0.323,-0.523l-0.28,0.548c-0.002,0.003 -0.003,0.007 -0.005,0.01c0.062,0.03 0.134,0.034 0.2,0.011l0.876,-0.308l-0.848,0.377c-0.065,0.029 -0.115,0.083 -0.139,0.149c0.01,0.004 0.02,0.008 0.03,0.011l0.6,0.151l-0.609,-0.103c-0.011,-0.002 -0.023,-0.003 -0.034,-0.002c-0.009,0.069 0.01,0.139 0.053,0.194l0.572,0.742l-0.628,-0.695c-0.043,-0.047 -0.101,-0.077 -0.163,-0.085c-0.001,0.01 -0.001,0.02 -0,0.03l0.048,0.616l-0.097,-0.611c-0.002,-0.012 -0.005,-0.024 -0.01,-0.036Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.96,52.75c-0.043,0.004 -0.082,0.027 -0.107,0.063l-0.295,0.433l0.259,-0.455c0.017,-0.03 0.023,-0.065 0.017,-0.099c-0.001,0 -0.002,0.001 -0.004,0.001l-0.322,0.13l0.31,-0.155c0.003,-0.001 0.005,-0.003 0.007,-0.004c-0,-0.001 -0.001,-0.002 -0.001,-0.002c-0.017,-0.042 -0.052,-0.074 -0.096,-0.088l-0.505,-0.151l0.515,0.111c0.037,0.008 0.076,0.001 0.108,-0.018l-0.224,-0.266l0.246,0.249c0,0 0,0 0,0c0.032,-0.029 0.049,-0.07 0.048,-0.113l-0.017,-0.526l0.059,0.524c0.005,0.042 0.027,0.079 0.06,0.104c0.001,-0.002 0.002,-0.003 0.003,-0.005l0.182,-0.295l-0.158,0.309c-0.001,0.002 -0.002,0.004 -0.003,0.006c0.035,0.017 0.076,0.019 0.113,0.006l0.494,-0.174l-0.478,0.213c-0.037,0.016 -0.065,0.047 -0.078,0.084c0.005,0.002 0.011,0.004 0.017,0.006l0.338,0.085l-0.344,-0.058c-0.006,-0.001 -0.013,-0.002 -0.019,-0.001c-0.005,0.039 0.006,0.078 0.03,0.11l0.323,0.419l-0.354,-0.392c-0.024,-0.027 -0.057,-0.044 -0.092,-0.048c-0.001,0.006 -0.001,0.011 -0,0.017l0.027,0.348l-0.055,-0.345c-0.001,-0.007 -0.003,-0.014 -0.005,-0.02Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.117,51.882c-0.043,0.004 -0.082,0.027 -0.107,0.063l-0.295,0.433l0.259,-0.455c0.017,-0.03 0.023,-0.065 0.017,-0.099c-0.001,0 -0.002,0.001 -0.004,0.001l-0.322,0.13l0.31,-0.155c0.003,-0.001 0.005,-0.003 0.007,-0.004c-0,-0.001 -0.001,-0.002 -0.001,-0.002c-0.017,-0.042 -0.052,-0.074 -0.096,-0.088l-0.505,-0.151l0.515,0.111c0.037,0.008 0.076,0.001 0.108,-0.018l-0.224,-0.266l0.246,0.249c0,0 0,0 0,0c0.032,-0.029 0.049,-0.07 0.048,-0.113l-0.017,-0.526l0.059,0.524c0.005,0.042 0.027,0.079 0.06,0.104c0.001,-0.002 0.002,-0.003 0.003,-0.005l0.182,-0.295l-0.158,0.309c-0.001,0.002 -0.002,0.004 -0.003,0.006c0.035,0.017 0.076,0.019 0.113,0.006l0.494,-0.174l-0.478,0.213c-0.037,0.016 -0.065,0.047 -0.078,0.084c0.005,0.002 0.011,0.004 0.017,0.006l0.338,0.085l-0.344,-0.058c-0.006,-0.001 -0.013,-0.002 -0.019,-0.001c-0.005,0.039 0.006,0.078 0.03,0.11l0.323,0.419l-0.354,-0.392c-0.024,-0.027 -0.057,-0.044 -0.092,-0.048c-0.001,0.006 -0.001,0.011 -0,0.017l0.027,0.348l-0.055,-0.345c-0.001,-0.007 -0.003,-0.014 -0.005,-0.02Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.094,51.051c-0.034,-0.028 -0.078,-0.039 -0.121,-0.031l-0.515,0.097l0.506,-0.138c0.033,-0.009 0.062,-0.03 0.081,-0.057c-0.001,-0.001 -0.002,-0.001 -0.004,-0.002l-0.322,-0.135l0.332,0.109c0.003,0.001 0.005,0.002 0.008,0.002c0,-0.001 0.001,-0.002 0.001,-0.002c0.017,-0.042 0.015,-0.089 -0.008,-0.129l-0.257,-0.462l0.292,0.441c0.021,0.032 0.054,0.054 0.09,0.063l0.025,-0.345l0.002,0.349c0,0 0,0 0,0c0.043,0.002 0.085,-0.015 0.114,-0.046l0.357,-0.383l-0.325,0.41c-0.026,0.033 -0.037,0.075 -0.03,0.116c0.002,-0 0.004,-0.001 0.006,-0.001l0.338,-0.08l-0.33,0.106c-0.002,0.001 -0.004,0.001 -0.006,0.002c0.014,0.037 0.041,0.067 0.077,0.083l0.477,0.225l-0.493,-0.187c-0.038,-0.014 -0.079,-0.013 -0.115,0.004c0.002,0.006 0.005,0.011 0.008,0.016l0.184,0.298l-0.206,-0.283c-0.004,-0.005 -0.008,-0.01 -0.013,-0.014c-0.031,0.024 -0.051,0.059 -0.055,0.098l-0.062,0.522l0.02,-0.526c0.001,-0.036 -0.01,-0.071 -0.032,-0.099c-0.004,0.004 -0.008,0.007 -0.012,0.012l-0.224,0.264l0.203,-0.281c0.004,-0.006 0.008,-0.012 0.01,-0.018Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.976,54.774c-0.019,0.034 -0.021,0.075 -0.007,0.112l0.172,0.442l-0.206,-0.427c-0.014,-0.028 -0.037,-0.051 -0.064,-0.064c-0,0.001 -0.001,0.002 -0.001,0.003l-0.065,0.305l0.041,-0.31c0,-0.003 0.001,-0.005 0.001,-0.008c-0.001,-0 -0.002,-0 -0.002,-0.001c-0.04,-0.009 -0.081,0 -0.113,0.026l-0.365,0.296l0.34,-0.324c0.025,-0.024 0.039,-0.056 0.041,-0.089l-0.308,0.029l0.307,-0.054c0,-0 0,-0 0,-0c-0.005,-0.038 -0.027,-0.073 -0.06,-0.094l-0.397,-0.259l0.416,0.227c0.033,0.018 0.072,0.021 0.107,0.009c-0.001,-0.002 -0.001,-0.003 -0.002,-0.005l-0.127,-0.287l0.149,0.276c0.001,0.002 0.002,0.003 0.003,0.005c0.03,-0.017 0.052,-0.046 0.061,-0.08l0.119,-0.456l-0.082,0.464c-0.006,0.036 0.002,0.072 0.023,0.101c0.005,-0.003 0.009,-0.006 0.013,-0.01l0.232,-0.207l-0.215,0.225c-0.004,0.004 -0.008,0.009 -0.011,0.014c0.026,0.024 0.061,0.036 0.096,0.034l0.471,-0.023l-0.467,0.06c-0.032,0.004 -0.061,0.02 -0.082,0.043c0.004,0.003 0.008,0.006 0.012,0.009l0.271,0.159l-0.282,-0.137c-0.006,-0.003 -0.012,-0.005 -0.018,-0.006Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", null, _clipPath20 || (_clipPath20 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.802,46.294l0.793,-3.343l3.094,1.572l2.709,7.507l-2.423,1.143l-4.172,-6.88Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip37)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image38",
    x: 62.802,
    y: 42.951,
    width: "7px",
    height: "11px"
  }))), _clipPath21 || (_clipPath21 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.802,46.294l0.793,-3.343l3.094,1.572l2.709,7.507l-2.423,1.143l-4.172,-6.88Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.721,47.967c1.598,2.403 5.704,0.672 6.158,0.481c0.344,1.186 2.373,4.678 -1.743,6.021c-2.096,0.684 -2.654,-1.728 -3.932,-4.76c-0.145,-0.345 -0.307,-1.656 -0.279,-1.737",
    style: {
      fill: "#0074ae",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.615,52.57c-0.077,-2.354 -1.466,-5.399 -2.601,-9.458c-0.392,-1.4 0.08,-1.004 1.089,0.293c5.383,6.916 3.241,8.475 2.713,8.859c-1,0.727 -0.828,1.087 -0.879,0.98",
    style: {
      fill: "#004a6f",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.894,46.345c0.08,-0.228 0.501,-0.445 0.553,-0.507c0.122,0.183 0.074,0.297 1.508,2.38c1.046,1.519 0.201,-0.091 -0.021,-0.5c-0.501,-0.922 -1.175,-2.082 -1.168,-2.133c0.008,-0.06 0.89,-0.587 0.312,-0.509c-0.055,0.007 -0.445,0.171 -0.445,0.171l-0.286,0.176c0,0 -0.346,0.456 -0.489,0.84",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.804,44.965c0.198,-0.092 0.787,-0.271 1.026,-0.407c0.007,-0.004 0.173,-0.095 0.094,-0.016c-0.168,0.17 -1.166,0.638 -1.231,0.524c-0.09,-0.157 0.136,-1.415 0.1,-0.751c-0.018,0.332 -0.034,0.328 -0.015,0.539c0.003,0.035 0.018,0.077 0.026,0.112Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.719,43.209c-0.164,2.029 -0.211,2.033 -0.177,2.216c0.003,0.017 8.434,14.495 2.072,3.825c-2.223,-3.728 -2.249,-3.785 -2.247,-3.811c0.165,-2.392 0.111,-2.56 0.298,-2.489c0.038,0.014 2.022,1.394 2.037,1.413c0.03,0.038 5.246,13.644 2.182,5.966c-1.901,-4.763 -2.32,-5.849 -2.324,-5.853c-0.129,-0.136 -0.155,-0.109 -1.841,-1.266Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.548,44.694c-0.177,-0.011 -1.34,-0.08 -2.885,-0.188c-0.09,-0.006 -0.113,0.069 -2.073,0.961c-0.172,0.078 -0.141,0.118 -1.804,2.415c1.57,-2.452 1.557,-2.462 1.614,-2.494c0.08,-0.044 1.412,-0.686 2.181,-1.027c0.07,-0.031 0.073,-0.007 2.967,0.333Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.618,46.25l0.793,-3.343c0.013,-0.057 0.052,-0.104 0.105,-0.128c0.053,-0.024 0.114,-0.023 0.166,0.003l3.094,1.572c0.043,0.022 0.076,0.059 0.093,0.105l2.709,7.507c0.033,0.092 -0.009,0.194 -0.098,0.236l-2.423,1.143c-0.088,0.041 -0.193,0.01 -0.243,-0.073l-4.172,-6.88c-0.026,-0.043 -0.034,-0.094 -0.022,-0.142Zm0.185,0.044l4.172,6.88l2.423,-1.143l-2.709,-7.507l-3.094,-1.572l-0.793,3.343Z",
    style: {
      fill: "#00ceff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.049,46.252c-0.055,-0.055 -0.131,-0.083 -0.208,-0.076l-0.927,0.079l0.918,-0.152c0.061,-0.01 0.115,-0.041 0.154,-0.087c-0.002,-0.001 -0.004,-0.002 -0.006,-0.003l-0.545,-0.295l0.566,0.252c0.005,0.002 0.009,0.004 0.014,0.006c0.001,-0.001 0.002,-0.003 0.002,-0.004c0.038,-0.07 0.042,-0.155 0.01,-0.229l-0.371,-0.86l0.437,0.829c0.032,0.06 0.085,0.106 0.148,0.127l0.106,-0.603l-0.058,0.614c-0,0 -0,0 -0,0c0.075,0.011 0.152,-0.011 0.209,-0.061l0.698,-0.61l-0.647,0.664c-0.052,0.053 -0.078,0.125 -0.073,0.199c0.003,-0 0.007,-0.001 0.01,-0.001l0.611,-0.08l-0.602,0.128c-0.004,0.001 -0.007,0.002 -0.011,0.003c0.017,0.067 0.06,0.125 0.12,0.161l0.802,0.483l-0.837,-0.418c-0.064,-0.032 -0.138,-0.036 -0.204,-0.013c0.003,0.01 0.007,0.02 0.011,0.03l0.271,0.558l-0.314,-0.535c-0.006,-0.01 -0.013,-0.019 -0.02,-0.028c-0.058,0.037 -0.1,0.095 -0.115,0.163l-0.203,0.909l0.13,-0.923c0.009,-0.063 -0.005,-0.127 -0.039,-0.18c-0.008,0.005 -0.016,0.012 -0.023,0.019l-0.444,0.425l0.408,-0.459c0.008,-0.009 0.015,-0.019 0.021,-0.03Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.875,48.19c-0.031,-0.031 -0.074,-0.047 -0.118,-0.043l-0.523,0.044l0.518,-0.086c0.034,-0.006 0.065,-0.023 0.087,-0.049c-0.001,-0.001 -0.002,-0.001 -0.003,-0.002l-0.307,-0.167l0.319,0.142c0.003,0.001 0.005,0.002 0.008,0.003c0,-0.001 0.001,-0.002 0.001,-0.002c0.021,-0.04 0.023,-0.087 0.005,-0.129l-0.209,-0.485l0.247,0.467c0.018,0.034 0.048,0.06 0.084,0.072l0.06,-0.34l-0.033,0.347c-0,0 -0,0 -0,0c0.043,0.006 0.086,-0.006 0.118,-0.034l0.394,-0.344l-0.365,0.375c-0.029,0.03 -0.044,0.071 -0.041,0.112c0.002,-0 0.004,-0 0.006,-0.001l0.345,-0.045l-0.34,0.072c-0.002,0 -0.004,0.001 -0.006,0.002c0.01,0.038 0.034,0.07 0.068,0.091l0.453,0.272l-0.472,-0.236c-0.036,-0.018 -0.078,-0.021 -0.115,-0.007c0.002,0.006 0.004,0.011 0.006,0.017l0.153,0.315l-0.177,-0.302c-0.003,-0.006 -0.007,-0.011 -0.011,-0.016c-0.033,0.021 -0.056,0.054 -0.065,0.092l-0.114,0.512l0.073,-0.52c0.005,-0.036 -0.003,-0.071 -0.022,-0.101c-0.005,0.003 -0.009,0.007 -0.013,0.01l-0.25,0.24l0.23,-0.259c0.005,-0.005 0.009,-0.011 0.012,-0.017Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.335,44.224c-0.031,-0.031 -0.074,-0.047 -0.118,-0.043l-0.523,0.044l0.518,-0.086c0.034,-0.006 0.065,-0.023 0.087,-0.049c-0.001,-0.001 -0.002,-0.001 -0.003,-0.002l-0.307,-0.167l0.319,0.142c0.003,0.001 0.005,0.002 0.008,0.003c0,-0.001 0.001,-0.002 0.001,-0.002c0.021,-0.04 0.023,-0.087 0.005,-0.129l-0.209,-0.485l0.247,0.467c0.018,0.034 0.048,0.06 0.084,0.072l0.06,-0.34l-0.033,0.347c-0,0 -0,0 -0,0c0.043,0.006 0.086,-0.006 0.118,-0.034l0.394,-0.344l-0.365,0.375c-0.029,0.03 -0.044,0.071 -0.041,0.112c0.002,-0 0.004,-0 0.006,-0.001l0.345,-0.045l-0.34,0.072c-0.002,0 -0.004,0.001 -0.006,0.002c0.01,0.038 0.034,0.07 0.068,0.091l0.453,0.272l-0.472,-0.236c-0.036,-0.018 -0.078,-0.021 -0.115,-0.007c0.002,0.006 0.004,0.011 0.006,0.017l0.153,0.315l-0.177,-0.302c-0.003,-0.006 -0.007,-0.011 -0.011,-0.016c-0.033,0.021 -0.056,0.054 -0.065,0.092l-0.114,0.512l0.073,-0.52c0.005,-0.036 -0.003,-0.071 -0.022,-0.101c-0.005,0.003 -0.009,0.007 -0.013,0.01l-0.25,0.24l0.23,-0.259c0.005,-0.005 0.009,-0.011 0.012,-0.017Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.69,44.137c-0.001,-0.044 -0.021,-0.085 -0.054,-0.113l-0.407,-0.337l0.432,0.304c0.029,0.02 0.063,0.029 0.097,0.027c-0,-0.001 -0.001,-0.003 -0.001,-0.004l-0.104,-0.334l0.13,0.325c0.001,0.003 0.002,0.005 0.004,0.008c0.001,-0 0.002,-0 0.003,-0.001c0.043,-0.013 0.078,-0.045 0.095,-0.087l0.19,-0.489l-0.151,0.503c-0.011,0.037 -0.007,0.076 0.01,0.11l0.282,-0.197l-0.267,0.221c-0,0 -0,0 -0,0c0.026,0.034 0.066,0.056 0.109,0.059l0.525,0.035l-0.525,0.007c-0.042,0.001 -0.081,0.019 -0.108,0.05c0.001,0.001 0.003,0.002 0.005,0.004l0.279,0.211l-0.295,-0.188c-0.002,-0.001 -0.004,-0.002 -0.005,-0.003c-0.019,0.033 -0.025,0.074 -0.015,0.112l0.134,0.51l-0.174,-0.498c-0.013,-0.038 -0.041,-0.069 -0.078,-0.086c-0.003,0.005 -0.005,0.011 -0.007,0.016l-0.111,0.329l0.085,-0.337c0.002,-0.006 0.003,-0.013 0.003,-0.019c-0.038,-0.009 -0.078,-0.002 -0.111,0.019l-0.442,0.28l0.418,-0.315c0.029,-0.021 0.048,-0.052 0.055,-0.087c-0.005,-0.001 -0.011,-0.002 -0.017,-0.002l-0.348,-0.007l0.347,-0.02c0.007,-0 0.014,-0.002 0.021,-0.003Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.683,48.702c-0.038,0.007 -0.071,0.031 -0.091,0.065l-0.229,0.411l0.196,-0.428c0.013,-0.028 0.015,-0.06 0.007,-0.09c-0.001,0 -0.002,0.001 -0.003,0.002l-0.277,0.142l0.265,-0.163c0.002,-0.001 0.004,-0.003 0.006,-0.004c-0,-0.001 -0.001,-0.001 -0.001,-0.002c-0.019,-0.036 -0.053,-0.062 -0.093,-0.071l-0.463,-0.095l0.469,0.058c0.034,0.004 0.068,-0.005 0.095,-0.025l-0.221,-0.22l0.24,0.203c0,0 0,0 0,0c0.026,-0.028 0.038,-0.067 0.034,-0.105l-0.057,-0.47l0.094,0.464c0.007,0.037 0.03,0.069 0.062,0.088c0.001,-0.001 0.002,-0.003 0.002,-0.005l0.139,-0.279l-0.117,0.289c-0.001,0.002 -0.001,0.004 -0.002,0.005c0.033,0.012 0.069,0.011 0.101,-0.004l0.428,-0.195l-0.411,0.228c-0.031,0.017 -0.054,0.047 -0.063,0.082c0.005,0.002 0.01,0.003 0.016,0.004l0.309,0.049l-0.312,-0.025c-0.006,-0 -0.012,-0 -0.017,0c-0.001,0.035 0.011,0.07 0.036,0.096l0.322,0.349l-0.348,-0.323c-0.024,-0.022 -0.054,-0.035 -0.086,-0.036c-0,0.005 0,0.01 0.001,0.015l0.052,0.309l-0.076,-0.304c-0.002,-0.006 -0.004,-0.012 -0.006,-0.018Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }))), /*#__PURE__*/React.createElement("g", null, _clipPath22 || (_clipPath22 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.845,52.157l2.882,-4.866l2.985,4.866l-1.683,3.948l-1.199,0.918l-2.985,-4.866Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip40)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image41",
    x: 63.845,
    y: 47.291,
    width: "6px",
    height: "10px"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M63.845,52.157l2.882,-4.866l2.985,4.866l-1.683,3.948l-1.199,0.918l-2.985,-4.866Z",
    style: {
      fill: "none",
      stroke: "#59bdff",
      strokeWidth: "0.08px"
    }
  }), _clipPath23 || (_clipPath23 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.727,47.291l0.103,9.732l-1.076,-0.656l-1.909,-4.21l5.867,-0.001"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip42)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image43",
    x: 63.845,
    y: 47.291,
    width: "6px",
    height: "10px"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M66.727,47.291l0.103,9.732l-1.076,-0.656l-1.909,-4.21l5.867,-0.001",
    style: {
      fill: "none",
      stroke: "#56c9ff",
      strokeWidth: "0.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.256,52.157l1.485,-2.526l1.538,2.526l-1.449,3.941l-1.575,-3.941Z",
    style: {
      fill: "#78f8ff"
    }
  }), _clipPath24 || (_clipPath24 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.256,52.157l1.485,-2.526l1.538,2.526l-1.449,3.941l-1.575,-3.941Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.073,50.71l3.123,2.564l-0.235,0.207l-3.123,-2.345l0.235,-0.427Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.203,50.513l3.15,2.322l-0.052,0.098l-3.107,-2.357l0.009,-0.062Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.256,52.157l1.485,-2.526l1.538,2.526l-1.449,3.941l-1.575,-3.941Z",
    style: {
      fill: "none",
      stroke: "#59bcff",
      strokeWidth: "0.08px"
    }
  })))), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "_Image14",
    width: "12px",
    height: "17px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAARCAYAAADpPU2iAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAoUlEQVQokY2SMQ7CMAxF329zKi7AhMTGGdmZWZlYK3GXUjM0FDdOFCx5yE++/eRY1OJlVtWBISiTGc3nkIIy5zLf1P563J2eDsVykk0qDY+M0sqAVKIMwBK1tcM9o9SqFloK1StVvTZy67CHDn+yY8BBSrz7GFviO/RMR+k31iVPpGU6afvv/WoYVBFdxOXzxhk4S32DNxaxuq+N/b9IpfQB9flLD+TUpwQAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image17",
    width: "5px",
    height: "11px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAALCAYAAAC3ZUeVAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAALklEQVQImWNkuPn/PwMaYEIXYGBgYGBhYGBgYPgPxf8gNAvDzwEV/IXpTqyOBwDASiWqm9rkOQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image20",
    width: "9px",
    height: "9px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAZ0lEQVQYlXWQMQqAQAwEJ3o+ydrayq9aW9v6IU9Yi5O7VXAgkCxDAgmcQ2IABqBrcV+7Xaq9gGhikTYJmeB00LOa4FiWOC3Qp54sISD/C4wRqQ75c0bAFFHOOb5xLgK8vvFwAUsTAG7geicGL6uijAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image23",
    width: "10px",
    height: "6px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAYAAAD68A/GAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAYklEQVQImV2NwQ2AMAwDz1KBVu0S7L8Ca1XigRQeCRDxiuNcbO3HZb3BaGJU6DFHg15FXQGgzBMkkAyhNMOT2BYo8/QFQPgTuOeu60iMgz7gn1wAHphUTapGOGgW8FuZkkPfhYwfc/ErJAoAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image25",
    width: "10px",
    height: "6px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAYAAAD68A/GAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAQUlEQVQImYXNQQqAMAwEwFFo//8NH9nGQyNKLXpYksCQ3RwRCipK5rnnvYOOlnPeMzf8wu2C8Y8H9K5aV89w8fUE4dsthWXsc9gAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image32",
    width: "14px",
    height: "15px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAlUlEQVQokY3SIRICMQyF4f/1PmgUCoVCckkUFoVC7HAA7kK3iC2zkzYp25mo9nvptBHvUmhXrrWTur26Uogy8HJCXZidevp4hXMAM/DocTJoHgTcLU7DTm0Z6B2Iwm5rVx+O8HXByz9NpYQBH//K9nG2dDavupc2YVoIcPiDiSDAMcDO7PSzeqr4FxBMaw8BztIIcZG+ZfaEyja7ZDEAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image35",
    width: "11px",
    height: "6px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAGCAYAAAAVMmT4AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAM0lEQVQYlc3PoQ0AIQAEwYH+u0NRygdxGHgHmk02ObHmip6A4Ds4gGqTi56Ky79acjy4mB48Lz2wuWXRAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image38",
    width: "7px",
    height: "11px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAALCAYAAACzkJeoAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAY0lEQVQYlXXQ2w3CQAxE0WO0xdAPpdIH+aaVaIPzsSYKCRnJsuTrkR/hnWmvxD0Cbj+gY8ZrGBr4FOhYKqNtxT0oGKbMv7DTzBfOEzw0XDuTAM+au1T4bqtu604aT3iMjxy1Av2COQ5LehXsAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image41",
    width: "6px",
    height: "10px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAKCAYAAACXDi8zAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAV0lEQVQImW2OQQqAMAwER+ir/bWCYhJxPaS2Rd3jZofJNF8SNRZgDhaiSLWILCzAA8q6qy/PgVi2XIyEJZGFBxz+jERZN30cnfDx2Bz9k19HfkNLc7xzA8dQdcwrap41AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image43",
    width: "6px",
    height: "10px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAKCAYAAACXDi8zAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAPElEQVQImWNkuPL/PwMDAwPDfyiGslkYfiE4yApYGH5jqmZggOn4j6kL1SjS7EDThceOvwxYARN2YQYGAMNlIrPrYHX3AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourIconStore);
export default __webpack_public_path__ + "static/media/tour_icon_store.be7ed3c22f1ca0c169649c152bc06d4d.svg";
export { ForwardRef as ReactComponent };